var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as e from "react";
import * as t from "react/jsx-runtime";
import * as n from "uitk-react-utils";
import * as a from "uitk-react-layout-flex";
import * as r from "uitk-react-layout-grid";
import * as i from "uitk-react-icons";
import * as o from "number-formatter";
import * as l from "@shared-ui/localization-context";
import * as s from "uitk-react-field";
import * as c from "uitk-react-text";
import * as d from "uitk-react-button";
import * as u from "uitk-react-badge";
import * as m from "tslib";
import * as h from "react-transition-group";
var p = {
    263: () => {},
    862: () => {},
    877: () => {},
    481: () => {},
    935: () => {},
    858: () => {},
    187: () => {},
    640: function (e, t) {
      !function (e) {
        function t(e, t, n, a) {
          var r,
            i = !1,
            o = 0;
          function l() {
            r && clearTimeout(r);
          }
          function s() {
            for (var s = arguments.length, c = new Array(s), d = 0; d < s; d++) c[d] = arguments[d];
            var u = this,
              m = Date.now() - o;
            function h() {
              o = Date.now(), n.apply(u, c);
            }
            i || (a && !r && h(), l(), void 0 === a && m > e ? h() : !0 !== t && (r = setTimeout(a ? function () {
              r = void 0;
            } : h, void 0 === a ? e - m : e)));
          }
          return "boolean" != typeof t && (a = n, n = t, t = void 0), s.cancel = function () {
            l(), i = !0;
          }, s;
        }
        e.debounce = function (e, n, a) {
          return void 0 === a ? t(e, n, !1) : t(e, a, !1 !== n);
        }, e.throttle = t, Object.defineProperty(e, "__esModule", {
          value: !0
        });
      }(t);
    }
  },
  f = {};
function g(e) {
  var t = f[e];
  if (void 0 !== t) return t.exports;
  var n = f[e] = {
    exports: {}
  };
  return p[e].call(n.exports, n, n.exports, g), n.exports;
}
g.n = e => {
  var t = e && e.__esModule ? () => e.default : () => e;
  return g.d(t, {
    a: t
  }), t;
}, g.d = (e, t) => {
  for (var n in t) g.o(t, n) && !g.o(e, n) && Object.defineProperty(e, n, {
    enumerable: !0,
    get: t[n]
  });
}, g.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), g.p = e;
})();
var v = {};
(() => {
  g.d(v, {
    AF: () => Re,
    Zb: () => tt,
    lr: () => We,
    o5: () => ue,
    RX: () => dt,
    N7: () => ee,
    q: () => we,
    jz: () => te,
    qv: () => V,
    E7: () => ye,
    et: () => ke,
    vl: () => me,
    yo: () => tn,
    h1: () => W,
    OR: () => R,
    SC: () => ca,
    F3: () => ie,
    zV: () => K,
    rb: () => mn,
    o8: () => An,
    eu: () => Q,
    QA: () => q
  });
  const p = (f = {
    Children: () => e.Children,
    Component: () => e.Component,
    Fragment: () => e.Fragment,
    cloneElement: () => e.cloneElement,
    createContext: () => e.createContext,
    createElement: () => e.createElement,
    createRef: () => e.createRef,
    default: () => e.default,
    forwardRef: () => e.forwardRef,
    isValidElement: () => e.isValidElement,
    useCallback: () => e.useCallback,
    useContext: () => e.useContext,
    useEffect: () => e.useEffect,
    useImperativeHandle: () => e.useImperativeHandle,
    useLayoutEffect: () => e.useLayoutEffect,
    useMemo: () => e.useMemo,
    useReducer: () => e.useReducer,
    useRef: () => e.useRef,
    useState: () => e.useState
  }, b = {}, g.d(b, f), b);
  var f, b;
  const y = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      Fragment: () => t.Fragment,
      jsx: () => t.jsx,
      jsxs: () => t.jsxs
    }),
    x = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      Level: () => n.Level,
      MakeEgdsSizingLength: () => n.MakeEgdsSizingLength,
      UitkContextProvider: () => n.UitkContextProvider,
      UitkContextWrapper: () => n.UitkContextWrapper,
      analyticsTracker: () => n.analyticsTracker,
      classNames: () => n.classNames,
      liveAnnounce: () => n.liveAnnounce,
      useUitkContext: () => n.useUitkContext,
      validatePropType: () => n.validatePropType
    }),
    k = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      UitkLayoutFlex: () => a.UitkLayoutFlex,
      UitkLayoutFlexItem: () => a.UitkLayoutFlexItem
    }),
    N = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      MinMax: () => r.MinMax,
      UitkLayoutGrid: () => r.UitkLayoutGrid,
      UitkLayoutGridItem: () => r.UitkLayoutGridItem
    }),
    E = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      UitkIcon: () => i.UitkIcon,
      UitkIconSize: () => i.UitkIconSize
    }),
    w = g.p + "./styles/egds-lodging-step-indicator.css",
    L = x.classNames.bind(w),
    C = e => {
      const {
          active: t,
          complete: n,
          content: a,
          direction: r,
          hasLeadingAndTrailingLines: i,
          icon: o,
          isDecorativeOnly: l,
          label: s,
          labelSize: c,
          stepIndicatorSize: d,
          trackLabelA11y: u
        } = e,
        m = L("step-indicator-stepper-content"),
        h = "step-indicator-stepper",
        p = L(h, {
          [`${h}-size-${d}`]: d,
          [`${h}-direction-${r}`]: r,
          [`${h}-complete`]: !l && n,
          [`${h}-active`]: !l && t,
          [`${h}-has-leading-and-trailing`]: l && "horizontal" === r && i
        }),
        f = L("step-indicator-stepper-marker"),
        g = "step-indicator-stepper-marker-circle",
        v = L(g, {
          [`${g}-size-${d}`]: d,
          [`${g}-has-icon`]: !l && o
        }),
        b = "step-indicator-stepper-label",
        x = L(b, {
          [`${b}-${c}`]: c
        });
      return (0, y.jsxs)(y.Fragment, {
        children: [(0, y.jsxs)("li", {
          className: p,
          children: [(0, y.jsx)("div", {
            className: f,
            children: (0, y.jsx)("div", {
              className: v,
              children: o && "large" === d && (0, y.jsx)(E.UitkIcon, {
                name: o,
                size: E.UitkIconSize.EXTRA_SMALL
              })
            })
          }), (s || a) && (0, y.jsxs)("div", {
            className: m,
            children: [s && (0, y.jsx)("span", {
              className: x,
              children: s
            }), a && (0, y.jsx)("div", {
              children: a
            })]
          })]
        }), u ? (k = u, (0, y.jsx)("li", {
          className: "sr-only",
          children: k
        })) : ""]
      });
      var k;
    };
  C.defaultProps = {
    content: null,
    icon: null,
    label: null,
    trackLabelA11y: null
  };
  const I = x.classNames.bind(w),
    R = e => {
      const {
          activeStep: t,
          direction: n,
          hasLeadingAndTrailingLines: a,
          isDecorativeOnly: r,
          labelSize: i,
          stepIndicatorSize: o,
          steps: l,
          stepLength: s
        } = e,
        c = r ? "decorative" : o,
        d = "step-indicator",
        u = I(d, {
          [`${d}-direction-${n}`]: n,
          [`${d}-step-length-${s}`]: s
        }),
        m = "step-indicator-stepper-label",
        h = I(m, {
          [`${m}-${i}`]: i
        });
      return "horizontal" === n ? (0, y.jsxs)(y.Fragment, {
        children: [(0, y.jsx)(k.UitkLayoutFlex, {
          justifyContent: "center",
          children: l.map((e, t) => t !== l.length - 1 ? (0, y.jsx)(k.UitkLayoutFlexItem, {
            style: {
              width: 100 / l.length + "%",
              textAlign: "center"
            },
            alignSelf: "center",
            children: (0, y.jsx)("span", {
              className: h,
              "aria-hidden": "true",
              children: e.trackLabelText ? e === null || e === void 0 ? void 0 : e.trackLabelText : null
            })
          }, `horizontal-track-label-${t}`) : null)
        }), (0, y.jsx)("ol", {
          className: u,
          children: l.map((e, o) => {
            const l = t === o + 1,
              s = o + 1 < t;
            return (0, p.createElement)(C, Object.assign(Object.assign({}, e), {
              active: l,
              complete: s,
              direction: n,
              hasLeadingAndTrailingLines: a,
              isDecorativeOnly: r,
              labelSize: i,
              key: e.label,
              stepIndicatorSize: c
            }));
          })
        })]
      }) : (0, y.jsxs)(N.UitkLayoutGrid, {
        columns: ["auto", "auto"],
        space: "two",
        children: [(0, y.jsx)(N.UitkLayoutGridItem, {
          children: (0, y.jsx)(k.UitkLayoutFlex, {
            direction: "column",
            justifyContent: "center",
            children: l.map((e, t) => t !== l.length - 1 ? (0, y.jsx)(k.UitkLayoutFlexItem, {
              alignSelf: "end",
              style: {
                height: 100 / l.length + "%",
                textAlign: "right"
              },
              children: (0, y.jsx)("span", {
                className: h,
                "aria-hidden": "true",
                children: e.trackLabelText ? e === null || e === void 0 ? void 0 : e.trackLabelText : null
              })
            }, `vertical-track-label-${t}`) : null)
          })
        }), (0, y.jsx)(N.UitkLayoutGridItem, {
          children: (0, y.jsx)("ol", {
            className: u,
            children: l === null || l === void 0 ? void 0 : l.map((e, o) => {
              const l = t === o + 1,
                s = o + 1 < t;
              return (0, p.createElement)(C, Object.assign(Object.assign({}, e), {
                active: l,
                complete: s,
                direction: n,
                hasLeadingAndTrailingLines: a,
                isDecorativeOnly: r,
                labelSize: i,
                key: e.label,
                stepIndicatorSize: c
              }));
            })
          })
        })]
      });
    };
  R.defaultProps = {
    direction: "horizontal",
    stepIndicatorSize: "small",
    stepLength: "equal",
    hasLeadingAndTrailingLines: !1,
    isDecorativeOnly: !1,
    labelSize: "medium"
  };
  const S = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      default: () => o.default
    }),
    _ = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      useLocalization: () => l.useLocalization
    }),
    A = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      UitkField: () => s.UitkField
    }),
    M = g.p + "./styles/egds-lodging-price-inputs.css",
    U = x.classNames.bind(M);
  class T extends p.Component {
    constructor(e) {
      super(e), this.state = {
        autofilled: !1,
        mounted: !1
      }, this.handleClear = this.handleClear.bind(this), this.setAutoFill = this.setAutoFill.bind(this), this.inputRef = e.domRef || p.createRef();
    }
    componentDidMount() {
      this.startTimer(), this.setState({
        mounted: !0
      });
    }
    componentWillUnmount() {
      const {
        domRef: e
      } = this.props;
      e && this.clearTimer();
    }
    handleClear() {
      var _a, _b;
      const {
        handleClear: e,
        onChange: t,
        id: n,
        name: a
      } = this.props;
      t && (t({
        target: {
          value: "",
          name: a !== null && a !== void 0 ? a : n
        }
      }), (_b = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus()), "function" == typeof e && e();
    }
    setAutoFill() {
      var _a;
      const e = (_a = this.inputRef) === null || _a === void 0 ? void 0 : _a.current;
      if (e) try {
        e.matches(":autofill") && (this.clearTimer(), this.setState({
          autofilled: !0
        }));
      } catch (t) {
        try {
          e.matches(":-webkit-autofill") && (this.clearTimer(), this.setState({
            autofilled: !0
          }));
        } catch (e) {
          return !1;
        }
      }
    }
    startTimer() {
      this.clearTimer(), this.autofillInput = setTimeout(() => {
        this.setAutoFill();
      }, 500);
    }
    clearTimer() {
      clearTimeout(this.autofillInput);
    }
    render() {
      const _a = this.props,
        {
          children: e,
          className: t,
          label: n,
          hasBorder: a,
          hasFloatedLabel: r,
          hasVisibleLabel: i,
          icon: o,
          instruction: l,
          invalid: s,
          l10n: c,
          hasClearButton: d,
          required: u,
          onBlur: m,
          onKeyPress: h,
          onChange: f
        } = _a,
        g = __rest(_a, ["children", "className", "label", "hasBorder", "hasFloatedLabel", "hasVisibleLabel", "icon", "instruction", "invalid", "l10n", "hasClearButton", "required", "onBlur", "onKeyPress", "onChange"]),
        {
          placeholder: v
        } = g,
        b = __rest(g, ["placeholder"]),
        {
          id: x,
          disabled: k,
          readOnly: N,
          value: w
        } = g,
        {
          autofilled: L,
          mounted: C
        } = this.state,
        I = C && d && w,
        R = {
          labelClassName: U(I && "has-input-cta"),
          disabled: k,
          hasAutofill: L,
          hasBorder: a,
          hasFloatedLabel: r,
          hasVisibleLabel: i,
          icon: o,
          id: x,
          instruction: l,
          invalid: s,
          label: n,
          placeholder: v,
          readOnly: N,
          required: u
        },
        S = b;
      S.domRef && delete S.domRef, S.handleClear && delete S.handleClear;
      const _ = U("uitk-field-input", I && "has-input-cta", t, !v && !w && "empty-placeholder", "remove-spinner");
      let M = n;
      if (p.isValidElement(n)) {
        const e = n.props;
        M = e && e.children && e.children[0];
      }
      const T = [c.formatText("clear"), M].join(" ");
      return (0, y.jsxs)(A.UitkField, Object.assign(Object.assign({}, R), {
        children: [(0, y.jsx)("input", Object.assign(Object.assign({}, S), {
          className: _,
          "aria-describedby": s ? `${x}-error` : void 0,
          placeholder: v,
          ref: this.inputRef,
          id: x,
          "aria-required": u,
          "aria-invalid": !!s,
          onBlur: m,
          onChange: f,
          onKeyPress: h
        })), e, I && C && (0, y.jsx)("button", {
          className: U("uitk-clear-button", "price-input-cta"),
          onClick: this.handleClear,
          type: "button",
          children: (0, y.jsx)(E.UitkIcon, {
            name: "cancel",
            size: E.UitkIconSize.SMALL,
            title: T,
            id: `${x}-clear-input-button`
          })
        })]
      }));
    }
  }
  T.defaultProps = {
    hasClearButton: !1,
    required: !1,
    value: ""
  };
  const B = e => {
    const t = (0, _.useLocalization)();
    return (0, y.jsx)(T, Object.assign({
      l10n: t
    }, e));
  };
  class P extends p.Component {
    render() {
      return (0, y.jsx)(B, Object.assign(Object.assign({}, this.props), {
        type: "text"
      }));
    }
  }
  P.displayName = "PriceTextInput";
  const j = g.p + "./styles/egds-lodging-price-slider.css",
    z = x.classNames.bind(j),
    F = p.forwardRef((e, t) => {
      const {
          absoluteMax: n,
          absoluteMin: a,
          disabled: r,
          formatValueForDisplay: i,
          gap: o,
          handleAfterChange: l,
          handleChange: s,
          id: c,
          isActive: d,
          label: u,
          lowerValue: m,
          max: h,
          min: f,
          name: g,
          onActive: v,
          step: b,
          type: x,
          upperValue: k,
          value: N,
          minDistance: E,
          displayLabel: w = !0
        } = e,
        L = p.useRef(null),
        [C, I] = p.useState(!1);
      p.useEffect(() => {
        I(!0);
      }, []);
      const R = (e, t) => {
          const r = h || n,
            i = f || a,
            l = t && t.target && t.target.value,
            s = l && parseInt(l, 10);
          switch (x) {
            case "primary":
              r - Math.min(r - o, s) >= E && e(Math.min(r - o, s), r, t);
              break;
            case "secondary":
              Math.max(i + o, s) - i >= E && e(i, Math.max(i + o, s), t);
              break;
            default:
              e(s);
          }
        },
        S = e => {
          "function" == typeof v && v(x), "function" == typeof s && R(s, e);
        },
        _ = e => {
          "function" == typeof l && R(l, e);
        };
      p.useImperativeHandle(t, () => ({
        changeValue: e => {
          S({
            target: {
              value: e,
              name: g
            }
          });
        },
        focus: () => {
          var _a;
          (_a = L.current) === null || _a === void 0 ? void 0 : _a.focus();
        },
        afterChange: e => {
          _({
            target: {
              value: e,
              name: g
            }
          });
        },
        getValue: () => {
          var _a, _b;
          return Number((_b = (_a = L.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 0);
        },
        blur: () => {
          var _a;
          (_a = L.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
      }), [S, _]);
      const A = p.createRef();
      let M;
      const U = ["price-slider-input"],
        T = {},
        B = {},
        P = `${c}-${x}`,
        j = h !== null && h !== void 0 ? h : n,
        F = f !== null && f !== void 0 ? f : a,
        O = m !== null && m !== void 0 ? m : a,
        V = k !== null && k !== void 0 ? k : n,
        D = N !== null && N !== void 0 ? N : a;
      switch (d && U.push("price-slider-input-active"), x) {
        case "primary":
          U.push("slider-primary"), M = 100 / ((j - a) / (O - a)), isFinite(M) || (M = 0), T["--slider-primary"] = `${M}%`, B.width = 100 / (n - a) * (V - a) + "%";
          break;
        case "secondary":
          U.push("slider-secondary"), M = 100 - 100 / ((j - F) / (j - V)), isFinite(M) || (M = 100), T["--slider-secondary"] = `${M}%`, B.width = 100 - 100 / (n - a) * (O - a) + "%";
          break;
        default:
          U.push("slider-single", "slider-primary"), M = 100 / ((j - F) / (D - F)), isFinite(M) || (M = 0), T["--slider-primary"] = `${M}%`, B.width = "100%";
      }
      const $ = "function" == typeof i ? i(D) : D,
        G = {
          "aria-label": u || g,
          "aria-valuetext": `${$}`,
          className: z(U),
          disabled: r,
          id: P,
          max: j,
          min: F,
          name: g,
          onChange: S,
          onKeyUp: _,
          onMouseUp: _,
          onTouchEnd: _,
          step: b,
          style: T
        };
      return (0, y.jsxs)(y.Fragment, {
        children: [(0, y.jsxs)("div", {
          className: z("price-slider"),
          style: B,
          children: [C ? (0, y.jsx)("input", Object.assign({
            type: "range",
            ref: L,
            "aria-valuemax": j,
            "aria-valuemin": F,
            "aria-valuenow": D,
            value: D
          }, G)) : (0, y.jsx)("input", Object.assign({
            type: "number",
            ref: L,
            "aria-valuemax": j,
            "aria-valuemin": F,
            "aria-valuenow": D,
            value: D
          }, G)), (0, y.jsx)("label", {
            className: "is-hidden",
            htmlFor: P,
            children: u || g
          })]
        }), w && (0, y.jsx)("span", {
          className: z(["price-slider-output"]),
          ref: A,
          "aria-hidden": "true",
          children: $
        })]
      });
    });
  F.displayName = "PriceSliderInput";
  const O = x.classNames.bind(j),
    V = e => {
      const {
          disabled: t,
          formatSecondaryValueForDisplay: n,
          formatValueForDisplay: a,
          gap: r,
          handleAfterChange: i,
          handleChange: o,
          lowerValue: l,
          max: s,
          min: c,
          name: d,
          primaryLabel: u,
          secondaryLabel: m,
          step: h,
          ticks: f,
          type: g,
          upperValue: v,
          value: b,
          minDistance: x = 0,
          displayLabel: k
        } = e,
        [N, E] = p.useState(""),
        [w, L] = p.useState(!1),
        [C, I] = p.useState(0),
        [R, S] = p.useState(!1),
        _ = p.useRef(null),
        A = p.useRef(null),
        M = p.useRef(null),
        U = p.useRef(null),
        T = p.useRef(null),
        B = !w && "dual" === g;
      p.useEffect(() => {
        S(!0), "dual" === g && ((() => {
          const e = r || 0,
            t = _ && _.current,
            n = t && t.offsetWidth;
          n && I(Math.floor((s - c) * e / n));
        })(), L("undefined" != typeof window && /Firefox\//.test(window.navigator.userAgent)));
      }, []);
      const P = (e, t, n) => {
          o(e, t, n);
        },
        j = (e, t, n) => {
          "function" == typeof i && i(e, t, n);
        },
        z = () => {
          void 0 !== g && E(g);
        },
        V = () => !R || t,
        D = e => {
          var _a, _b;
          const t = _.current.getBoundingClientRect(),
            n = e.clientX > t.left && e.clientX < t.right;
          let a = e.clientX - t.left;
          n || (a = e.clientX < t.left ? 0 : t.width);
          const r = (i = [0, _.current.offsetWidth], o = [c, s], e => {
            if (i[0] === i[1] || o[0] === o[1]) return o[0];
            return o[0] + (o[1] - o[0]) / (i[1] - i[0]) * (e - i[0]);
          });
          var i, o;
          const d = r(a),
            u = Math.abs(d - l) < Math.abs(d - v);
          T.current = u ? M.current : U.current;
          const m = Math.min(Math.max(d, c), s);
          (_a = T.current) === null || _a === void 0 ? void 0 : _a.focus(), (_b = T.current) === null || _b === void 0 ? void 0 : _b.changeValue(m);
        },
        $ = ["price-slider-container", ...(f ? ["price-slider-container-has-ticks"] : [])],
        G = "function" == typeof n ? n : a,
        W = {
          "--min": c,
          "--max": s,
          "--step": h
        };
      return V() && $.push("price-slider-container-disabled"), void 0 === h && $.push("price-slider-container-no-step"), (0, y.jsxs)("div", {
        "data-testid": "price-slider-container",
        className: O($),
        ref: _,
        style: W,
        children: ["dual" === g && w && (0, y.jsx)("input", {
          type: "hidden",
          value: l,
          name: d
        }), (0, y.jsx)(F, Object.assign(Object.assign({}, e), {
          type: B ? "primary" : "single",
          name: d,
          max: B ? v : s,
          value: B ? l : b || v,
          absoluteMax: s,
          absoluteMin: c,
          gap: C,
          isActive: "primary" === N,
          onActive: z,
          disabled: V(),
          handleChange: P,
          handleAfterChange: j,
          formatValueForDisplay: a,
          label: B ? u : void 0,
          minDistance: x,
          displayLabel: k,
          ref: M
        })), B && (0, y.jsx)(F, Object.assign(Object.assign({}, e), {
          type: "secondary",
          name: d,
          ref: U,
          min: l,
          value: v,
          absoluteMax: s,
          absoluteMin: c,
          gap: C,
          isActive: "secondary" === N,
          onActive: z,
          disabled: V(),
          handleChange: P,
          handleAfterChange: j,
          formatValueForDisplay: G,
          label: m,
          minDistance: x,
          displayLabel: k
        })), B && (0, y.jsx)("div", {
          "aria-hidden": "true",
          className: O("price-slider-tracker"),
          "data-testid": "price-slider-tracker",
          ref: A,
          onPointerDown: e => {
            e.preventDefault(), A.current.setPointerCapture(e.pointerId), D(e);
          },
          onPointerMove: e => {
            e.target.hasPointerCapture(e.pointerId) && D(e);
          },
          onPointerUp: e => {
            A.current.releasePointerCapture(e.pointerId), T.current.afterChange(T.current.getValue()), T.current.blur(), T.current = null;
          }
        })]
      });
    };
  V.displayName = "PriceSlider";
  const D = g.p + "./styles/egds-lodging-slider-text-inputs.css",
    $ = x.classNames.bind(D),
    G = (e, t, n, a) => {
      const {
        template: r,
        models: i
      } = e;
      return `${n || i.reduce((e, {
        key: n,
        source: a
      }) => {
        const r = (i = t, a.split(".").reduce((e, t) => e === null || e === void 0 ? void 0 : e[t], i));
        var i;
        return e.replace(`{${n}}`, r);
      }, r)}, ${e.text}, ${a}`;
    },
    W = e => {
      const {
          fieldId: t,
          minValueInput: n,
          maxValueInput: a,
          range: r,
          minValueAccessibility: i,
          maxValueAccessibility: o,
          numberFormat: l,
          shouldShowSeperator: s,
          rangeSliderId: c,
          lowerBoundAccessibility: d,
          upperBoundAccessibility: u,
          onMinChange: m,
          onMaxChange: h,
          onRangeChange: f,
          onRangeAfterChange: g,
          resetFilters: v,
          type: b,
          allowUserMax: x
        } = e,
        {
          value: k,
          label: E
        } = n,
        {
          value: w,
          label: L
        } = a,
        {
          characteristics: C,
          selected: I
        } = r,
        {
          min: R,
          max: _,
          minLabel: A,
          maxLabel: M
        } = C,
        {
          step: U
        } = C,
        {
          min: T,
          max: B,
          id: j
        } = I,
        [z, F] = p.default.useState(T),
        [O, D] = p.default.useState(B),
        [W, H] = p.default.useState(k),
        [q, Y] = p.default.useState(w),
        [X, K] = p.default.useState(T),
        [Q, Z] = p.default.useState(B),
        [J, ee] = p.default.useState(Q),
        te = p.default.useMemo(() => {
          const t = Object.assign(Object.assign({}, e), {
            range: {
              characteristics: C,
              selected: {
                id: j,
                min: z,
                max: O
              }
            }
          });
          return G(i, t, z === R ? d : "", b);
        }, [z]),
        ne = p.default.useMemo(() => {
          const t = Object.assign(Object.assign({}, e), {
            range: {
              characteristics: C,
              selected: {
                id: j,
                min: z,
                max: O
              }
            }
          });
          return G(o, t, O === _ ? u : "", b);
        }, [O]),
        ae = !("undefined" != typeof window && /Firefox\//.test(window.navigator.userAgent)),
        re = e => e === R ? A : e === _ ? M : l ? (0, S.default)(l, e) : e;
      p.default.useEffect(() => {
        F(T), D(B);
      }, [I]), p.default.useEffect(() => {
        v && (F(R), D(_), H(A), Y(M), K(R), Z(_), ee(_));
      }, [v]), p.default.useEffect(() => {
        z < O && (H(re(z)), Y(re(O)), K(z), Z(O));
      }, [z, O]);
      const ie = e => {
          const {
              code: t
            } = e,
            {
              key: n
            } = e;
          "Enter" !== e.key && 13 !== parseInt(e.key, 10) && 10 !== parseInt(e.key, 10) || e.currentTarget.blur(), (Number(t) < 48 || Number(t) > 57) && e.preventDefault(), Number(n) >= 0 || Number(n) <= 9 || e.preventDefault();
        },
        oe = s ? ["2fr", "0", "2fr"] : ["2fr", "2fr"],
        le = s ? {
          column: "four"
        } : {
          column: "two"
        },
        se = $(ae ? "slider-text-input--input_container" : "slider-text-input--input_container--firefox"),
        ce = $("slider-text-input--container"),
        de = $("separator"),
        ue = $("slider-text-input--slider");
      return (0, y.jsxs)("div", {
        className: ce,
        children: [(0, y.jsx)("div", {
          className: se,
          children: (0, y.jsxs)(N.UitkLayoutGrid, {
            columns: oe,
            space: le,
            justifyContent: "space-between",
            children: [(0, y.jsx)(N.UitkLayoutGridItem, {
              children: (0, y.jsx)(P, {
                "aria-label": te,
                id: `${t}-min`,
                label: E,
                hasFloatedLabel: !1,
                hasVisibleLabel: !0,
                onBlur: e => {
                  const t = e.target.value,
                    n = parseInt(t, 10);
                  Number.isNaN(n) || n === z || "" === t || n >= O ? H(re(z)) : (F(parseInt(t, 10)), m === null || m === void 0 ? void 0 : m(e, parseInt(t, 10), O));
                },
                onChange: e => {
                  const t = e.target.value;
                  H(t);
                },
                onFocus: () => {
                  H("");
                },
                value: W,
                onKeyPress: ie
              })
            }), (0, y.jsx)(N.UitkLayoutGridItem, {
              alignSelf: "center",
              justifySelf: "center",
              children: s && (0, y.jsx)("div", {
                className: de
              })
            }), (0, y.jsx)(N.UitkLayoutGridItem, {
              children: (0, y.jsx)(P, {
                "aria-label": ne,
                id: `${t}-max`,
                label: L,
                hasFloatedLabel: !1,
                hasVisibleLabel: !0,
                onBlur: e => {
                  let t = e.target.value;
                  const n = parseInt(t, 10);
                  Number.isNaN(n) || !x && n > _ || "" === t || n <= z || n > 1e7 ? (t = Q.toString(), Y(re(O))) : (D(parseInt(t, 10)), h === null || h === void 0 ? void 0 : h(e, z, parseInt(t, 10)), x && (Z(n), ee(n)));
                },
                onChange: e => {
                  const t = e.target.value;
                  Y(t);
                },
                onFocus: () => {
                  Y("");
                },
                value: q,
                onKeyPress: ie
              })
            })]
          })
        }), ae && (0, y.jsx)("div", {
          className: ue,
          children: (0, y.jsx)(V, {
            id: c,
            name: t,
            type: "dual",
            min: R,
            max: x ? Math.max(_, J) : _,
            step: U,
            handleChange: (e, t) => {
              t ? (F(e), D(x || t <= _ ? t : R), f === null || f === void 0 ? void 0 : f(e, t)) : (F(e), f === null || f === void 0 ? void 0 : f(e, null));
            },
            handleAfterChange: (e, t, n) => {
              g === null || g === void 0 ? void 0 : g(n, e, t);
            },
            lowerValue: X,
            upperValue: Q,
            primaryLabel: te,
            secondaryLabel: ne,
            displayLabel: !1
          })
        })]
      });
    };
  W.defaultProps = {
    numberFormat: null,
    minValueAccessibility: null,
    maxValueAccessibility: null,
    shouldShowSeperator: !1,
    rangeSliderId: null,
    lowerBoundAccessibility: null,
    upperBoundAccessibility: null,
    resetFilters: !1
  };
  const H = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      UitkText: () => c.UitkText
    }),
    q = {
      LOW: "lowtier",
      MID: "midtier",
      HIGH: "hightier",
      EXTRAHIGH: "extrahightier",
      VIP: "vip"
    },
    Y = g.p + "./styles/egds-lodging-text-loyalty-themes.css",
    X = x.classNames.bind(Y),
    K = e => {
      const {
          children: t,
          align: n,
          dataTestId: a,
          wordBreak: r,
          theme: i,
          className: o,
          whiteSpace: l,
          weight: s,
          size: c,
          hyphens: d,
          overflow: u,
          spacing: m,
          inline: h
        } = e,
        p = X(`uitk-text-loyalty-${i}`, o),
        f = i && i === (q.LOW || q.HIGH || q.MID || q.EXTRAHIGH);
      return (0, y.jsx)(H.UitkText, {
        className: p,
        align: n,
        dataTestId: a,
        wordBreak: r,
        whiteSpace: l,
        weight: s,
        size: c,
        hyphens: d,
        overflow: u,
        spacing: m,
        inline: h,
        theme: f ? "default" : i,
        children: t
      });
    };
  K.displayName = "TextLoyaltyThemes";
  const Q = {
      LOW: "lowtier",
      MID: "midtier",
      HIGH: "hightier",
      EXTRAHIGH: "extrahightier",
      VIP: "vip"
    },
    Z = g.p + "./styles/egds-lodging-icon-loyalty-themes.css",
    J = x.classNames.bind(Z),
    ee = e => {
      const {
          className: t,
          description: n,
          getMarkerPopup: a,
          id: r,
          name: i,
          shadow: o,
          spotlight: l,
          size: s,
          theme: c,
          title: d
        } = e,
        u = J(`uitk-icon-loyalty-${c}`, t),
        m = c && c === (Q.LOW || Q.HIGH || Q.MID || Q.EXTRAHIGH);
      return (0, y.jsx)(E.UitkIcon, {
        className: u,
        description: n,
        getMarkerPopup: a,
        id: r,
        name: i,
        shadow: o,
        spotlight: l,
        size: s,
        theme: m ? "default" : c,
        title: d
      });
    };
  ee.displayName = "IconLoyaltyThemes";
  class te extends p.Component {
    render() {
      return (0, y.jsx)(B, Object.assign(Object.assign({}, this.props), {
        type: "number"
      }));
    }
  }
  te.displayName = "PriceNumberInput";
  const ne = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      UitkButton: () => d.UitkButton,
      UitkPagingNextButton: () => d.UitkPagingNextButton,
      UitkPagingPrevButton: () => d.UitkPagingPrevButton,
      UitkSecondaryButton: () => d.UitkSecondaryButton,
      UitkTertiaryButton: () => d.UitkTertiaryButton
    }),
    ae = g.p + "./styles/egds-lodging-tertiary-button-large-icon-with-text.css",
    re = x.classNames.bind(ae),
    ie = e => {
      const {
          className: t,
          largeIcon: n
        } = e,
        a = __rest(e, ["className", "largeIcon"]),
        r = re(n ? `${ne.UitkButton.baseClassName}-tertiary-large-icon` : null, t);
      return (0, y.jsx)(x.UitkContextWrapper, {
        children: e => (0, y.jsx)(ne.UitkTertiaryButton, Object.assign(Object.assign({}, a), {
          className: r,
          "data-context": e
        }))
      });
    };
  ie.displayName = "TertiaryButtonLargeIcon";
  const oe = new Map([["default", "default"], ["inverse", "inverse"]]),
    le = new Map([["small", "small"], ["medium", "medium"], ["large", "large"]]),
    se = new Map([["left", "left"], ["center", "center"], ["right", "right"]]),
    ce = g.p + "./styles/egds-lodging-neutral-color-link.css",
    de = x.classNames.bind(ce),
    ue = e => {
      const {
          children: t,
          className: n,
          align: a = se.get("left"),
          theme: r = oe.get("default"),
          inline: i = !1,
          noWrap: o = !1,
          analytics: l,
          size: s = le.get("medium"),
          disabled: c,
          domRef: d
        } = e,
        u = __rest(e, ["children", "className", "align", "theme", "inline", "noWrap", "analytics", "size", "disabled", "domRef"]),
        {
          data: m
        } = (0, x.useUitkContext)(),
        {
          contextClassNames: h
        } = m !== null && m !== void 0 ? m : {},
        f = p.Children.toArray(t)[0],
        g = de("neutral-color-link", h === null || h === void 0 ? void 0 : h.Link, n, {
          [`neutral-color-link-align-${a}`]: a,
          "neutral-color-link-theme-inverse": "inverse" === r,
          "neutral-color-link-no-wrap": o,
          "neutral-color-link-layout-inline": i,
          "neutral-color-link-layout-default": !i,
          [`neutral-color-link-${s}`]: s && le.get(s),
          "neutral-color-link-disabled": !!c
        }),
        v = f.props.children,
        b = de(`neutral-color-link-icon-${s}`, {
          "neutral-color-link-inverse-icon": "inverse" === r
        }),
        y = [],
        k = "button" === (f === null || f === void 0 ? void 0 : f.type),
        N = c && k;
      p.Children.map(v, e => {
        var _a;
        "UitkIcon" === ((_a = e === null || e === void 0 ? void 0 : e.type) === null || _a === void 0 ? void 0 : _a.displayName) ? y.push(p.cloneElement(e, {
          className: de(b)
        })) : y.push(e);
      });
      const E = p.useCallback(() => {
          if (l) return (0, x.analyticsTracker)(l);
        }, [l]),
        w = f.props.onClickCapture || e.onClickCapture || E;
      return p.cloneElement(f, Object.assign(Object.assign(Object.assign(Object.assign({
        analytics: l,
        children: y,
        ref: d,
        className: g
      }, u), {
        onClickCapture: w
      }), N && {
        tabIndex: -1,
        disabled: !0
      }), !k && {
        role: "link",
        "aria-disabled": c || void 0
      }));
    };
  ue.displayName = "EGDSLocalNeutralColorLink";
  const me = p.createContext(null),
    he = g.p + "./styles/egds-lodging-radio-button-description-extension-with-positive-theme.css",
    pe = x.classNames.bind(he);
  var fe;
  !function (e) {
    e.EMPHASIS = "EMPHASIS", e.INVERSE = "INVERSE", e.LOYALTY = "LOYALTY", e.NEGATIVE = "NEGATIVE", e.POSITIVE = "POSITIVE", e.PRIMARY = "PRIMARY", e.SECONDARY = "SECONDARY";
  }(fe || (fe = {}));
  const ge = {
    [fe.EMPHASIS]: "emphasis",
    [fe.LOYALTY]: "loyalty",
    [fe.INVERSE]: "inverse",
    [fe.NEGATIVE]: "negative",
    [fe.POSITIVE]: "positive",
    [fe.PRIMARY]: "emphasis",
    [fe.SECONDARY]: "default"
  };
  var ve;
  !function (e) {
    e.BOLD = "BOLD", e.MEDIUM = "MEDIUM", e.REGULAR = "REGULAR";
  }(ve || (ve = {}));
  const be = {
      [ve.BOLD]: "bold",
      [ve.MEDIUM]: "medium",
      [ve.REGULAR]: "regular"
    },
    ye = e => {
      let t = !1;
      "undefined" != typeof window && (t = window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      const {
          className: n,
          children: a,
          checked: r,
          description: i,
          descriptionList: o,
          disabled: l,
          id: s,
          label: c,
          labelClassName: d,
          labelSuffix: u,
          required: m,
          name: h,
          value: f,
          a11yLabel: g,
          onChange: v
        } = e,
        b = (0, p.useContext)(me),
        N = "uitk-radio-button",
        E = `${N}-label-haslabelsuffix`,
        w = pe(N, {
          "is-disabled": l
        }),
        L = pe("uitk-radio-button-label", E, {
          [d]: Boolean(d),
          "is-required": m
        }),
        C = pe({
          checked: r
        }, n),
        I = (b === null || b === void 0 ? void 0 : b.defaultChecked) ? "defaultChecked" : "checked",
        R = r || (b === null || b === void 0 ? void 0 : b.selected) === f,
        S = pe(`${N}-control`),
        _ = pe(`${N}-has-reduced-motion`),
        {
          data: A
        } = (0, x.useUitkContext)(),
        {
          hasRequiredFieldIndicator: M
        } = A !== null && A !== void 0 ? A : {},
        U = `radio-button-description-${p.useMemo(() => Math.random().toString(36).substring(7), [])}`,
        T = i || (o === null || o === void 0 ? void 0 : o.reduce((e, t) => `${e}${t.accessibility || t.text}. `, "")) || "",
        B = g && [g, u].filter(Boolean).join(", ").concat(".");
      return (0, y.jsx)(k.UitkLayoutFlex, {
        className: w,
        wrap: "nowrap",
        children: (0, y.jsx)(k.UitkLayoutFlexItem, {
          className: pe(`${N}-content`),
          grow: 1,
          children: (0, y.jsx)("div", {
            children: (0, y.jsxs)("label", {
              className: L,
              htmlFor: s,
              children: [(0, y.jsx)("input", {
                type: "radio",
                name: h || (b === null || b === void 0 ? void 0 : b.group),
                id: s,
                [I]: R,
                className: C,
                onChange: v || (b === null || b === void 0 ? void 0 : b.onChange),
                value: f,
                disabled: l,
                "aria-label": B,
                "aria-describedby": U
              }), (0, y.jsx)("span", {
                "aria-hidden": "true",
                className: t ? `${S} ${_}` : S
              }), (0, y.jsxs)("div", {
                "aria-hidden": Boolean(g && c),
                className: pe(`${N}-label-content`),
                children: [c || a, m && M && (0, y.jsxs)("span", {
                  className: "uitk-radio-button-required-asterisk",
                  "aria-hidden": "true",
                  children: [" ", "*"]
                })]
              }), u && (0, y.jsx)("span", {
                "aria-hidden": Boolean(g),
                className: pe(`${N}-label-suffix`),
                children: u
              }), T && (0, y.jsx)("span", {
                className: "is-hidden",
                id: U,
                children: T
              }), i && (0, y.jsx)("span", {
                "aria-hidden": Boolean(g),
                className: pe(`${N}-description uitk-type-200`),
                children: i
              }), o && o.length > 0 && (0, y.jsx)("div", {
                "aria-hidden": Boolean(g),
                className: pe(`${N}-descriptions-container`),
                children: o === null || o === void 0 ? void 0 : o.map((e, t) => (0, y.jsx)(H.UitkText, {
                  className: pe(`${N}-description-list-item uitk-type-200`),
                  theme: ge[(e === null || e === void 0 ? void 0 : e.theme) || fe.SECONDARY],
                  weight: be[(e === null || e === void 0 ? void 0 : e.weight) || ve.REGULAR],
                  children: e.text
                }, `radio-button-description-${t}`))
              })]
            })
          })
        })
      });
    },
    xe = x.classNames.bind(he),
    ke = e => {
      const {
          children: t,
          className: n,
          defaultChecked: a,
          errorMessage: r,
          group: i,
          legendLabel: o,
          selected: l,
          onChange: s
        } = e,
        c = xe("uitk-radio-button-group", n),
        d = xe("uitk-radio-button-error"),
        {
          data: u
        } = (0, x.useUitkContext)(),
        {
          hasRequiredFieldIndicator: m,
          collapsed: h,
          srMessage: f
        } = u !== null && u !== void 0 ? u : {},
        g = {
          onChange: s,
          defaultChecked: a,
          group: i,
          selected: l,
          hasRequiredFieldIndicator: m
        },
        v = p.useMemo(() => Object.assign({}, g), [g]),
        b = `legend-${p.useMemo(() => Math.random().toString(36).substring(7), [])}`;
      return (0, y.jsxs)("fieldset", {
        className: c,
        "aria-labelledby": b,
        children: [(0, y.jsxs)("legend", {
          className: "is-hidden",
          id: b,
          children: [o || i, h && (f ? `. ${f}` : "")]
        }), r && (0, y.jsx)("p", {
          className: d,
          children: r
        }), (0, y.jsx)(me.Provider, {
          value: v,
          children: t
        })]
      });
    },
    Ne = (e => {
      var t = {};
      return g.d(t, e), t;
    })({
      UitkBadgeLoyalty: () => u.UitkBadgeLoyalty,
      UitkBadgeStandard: () => u.UitkBadgeStandard
    }),
    Ee = g.p + "./styles/egds-lodging-loyalty-badge-muted.css";
  x.classNames.bind(Ee);
  const we = e => {
    const {
      theme: t
    } = e;
    return (0, y.jsx)(Ne.UitkBadgeLoyalty, Object.assign(Object.assign({}, e), {
      className: `${t}-muted`
    }));
  };
  we.displayName = "LoyaltyBadgeMuted";
  const Le = g.p + "./styles/egds-lodging-calendar-rates-background.css",
    Ce = new Map([["default", "calendar-rates-background-default"], ["positive", "calendar-rates-background-positive"], ["negative", "calendar-rates-background-negative"], ["neutral", "calendar-rates-background-neutral"]]),
    Ie = x.classNames.bind(Le),
    Re = e => {
      const {
          children: t,
          className: n,
          dataTestId: a,
          theme: r,
          backgroundShape: i
        } = e,
        o = Ie("calendar-rates-background", {
          "calendar-rates-background-flat": "default" === r || "flat" === i
        }, {
          "calendar-rates-background-rounded": "rounded" === i
        }, {
          "calendar-rates-background-circle": "circle" === i
        }, Ce.get(r), n);
      return (0, y.jsx)("div", {
        className: o,
        "data-test-id": a,
        children: t
      });
    };
  Re.displayName = "CalendarRatesBackground";
  const Se = (e => {
    var t = {};
    return g.d(t, e), t;
  })({
    __assign: () => m.__assign,
    __extends: () => m.__extends,
    __rest: () => m.__rest,
    __spreadArray: () => m.__spreadArray
  });
  var _e = g(640),
    Ae = g(862),
    Me = g.n(Ae),
    Ue = (new Map([["sm", "sm"], ["md", "md"], ["lg", "lg"], ["xl", "xl"]]), new Map([["h1", "h1"], ["h2", "h2"], ["h3", "h3"], ["h4", "h4"], ["h5", "h5"], ["h6", "h6"]])),
    Te = x.classNames.bind(Me()),
    Be = function (e) {
      var t = e.children,
        n = e.wrapItems,
        a = e.ariaHidden,
        r = e.ariaLabel,
        i = e.stretchToFill,
        o = e.carouselContainerRef,
        l = e.itemIndex,
        s = p.useState(!1),
        c = s[0],
        d = s[1],
        u = p.useRef(null),
        m = (0, x.useUitkContext)().data,
        h = null != m ? m : {},
        f = h.carouselWindowWidth,
        g = h.carouselSize,
        v = h.isNaturalWidthItemsCarousel,
        b = h.setSnapPointItem,
        y = h.setNaturalWidthItemsViewed,
        k = h.setNaturalWidthItemsInView,
        N = h.isRtl,
        E = h.carouselIsVisible,
        w = "uitk-carousel-item";
      return i || (w += " uitk-carousel-item-size-auto"), ("undefined" == typeof window ? p.useEffect : p.useLayoutEffect)(function () {
        var e, t;
        if (N) {
          var n = null === (e = u.current) || void 0 === e ? void 0 : e.getBoundingClientRect().width;
          void 0 !== l && n && b && b({
            payload: {
              itemIndex: l,
              snapPoint: n
            }
          });
        } else {
          var a = null === (t = u.current) || void 0 === t ? void 0 : t.offsetLeft;
          b && b({
            payload: {
              itemIndex: l,
              snapPoint: a
            }
          });
        }
      }, [f, E, g, N]), p.useEffect(function () {
        var e = {
            threshold: [0, .25, .5, .75, 1],
            root: null == o ? void 0 : o.current
          },
          t = new IntersectionObserver(function (e) {
            e.forEach(function (e) {
              var t = 1 === e.intersectionRatio;
              d(t), k({
                payload: {
                  itemIndex: l,
                  inView: t
                }
              }), t && y({
                payload: {
                  itemIndex: l
                }
              });
            });
          }, e),
          n = u.current;
        return v && n && t.observe(n), function () {
          n && t.unobserve(n);
        };
      }, [o, v, l, y, k]), function (e) {
        var t = n ? e.props.className : "",
          i = !v && a || v && !c,
          o = (0, Se.__assign)((0, Se.__assign)({}, i ? {
            "aria-hidden": !0,
            tabIndex: -1
          } : null), {
            className: Te(t ? "".concat(t, " ").concat(w) : w),
            "data-stid": "carousel-item",
            "aria-label": r,
            ref: u
          });
        if (u.current) {
          var l = u.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          Array.from(l).filter(function (e) {
            return !e.hasAttribute("aria-hidden");
          }).forEach(function (e) {
            e[i ? "setAttribute" : "removeAttribute"]("tabindex", "-1");
          });
        }
        return n ? p.createElement("div", (0, Se.__assign)({}, o), e) : p.cloneElement(e, o);
      }(t);
    };
  Be.displayName = "UitkCarouselItem", Be.defaultProps = {
    wrapItems: !0
  };
  var Pe = function (e) {
    var t,
      n,
      a,
      r,
      i = e.children,
      o = e.l10n,
      l = e.size,
      s = e.currentIndex,
      c = e.itemCount,
      d = (0, Se.__rest)(e, ["children", "l10n", "size", "currentIndex", "itemCount"]),
      u = d.itemsVisible,
      m = p.Children.toArray(i);
    return p.createElement(p.Fragment, null, (t = m, n = u[l], a = s, r = s + n, p.Children.map(t, function (e, t) {
      var n = t < a || t >= r,
        i = null == o ? void 0 : o.formatText("carousel.indexAndTotal", t + 1, c);
      return p.createElement(Be, (0, Se.__assign)({
        key: t,
        itemIndex: t,
        ariaHidden: n,
        ariaLabel: i
      }, d), e);
    })));
  };
  Pe.displayName = "UitkCarouselItemList";
  var je = x.classNames.bind(Me()),
    ze = function (e) {
      var t,
        n = e.analytics,
        a = e.buttonText,
        r = e.carouselName,
        i = e.naturalWidthItems,
        o = e.currentIndex,
        l = e.carouselContainerRef,
        s = e.itemCount,
        c = e.itemsVisible,
        d = e.fullSheetVisible,
        u = e.navigationIconId,
        m = e.onNextCb,
        h = e.onPrevCb,
        f = e.pagingOverlay,
        g = e.scrollEventOngoing,
        v = void 0 !== g && g,
        b = e.size,
        y = e.isRtl,
        x = e.renderPrevNavButton,
        k = void 0 !== x && x,
        N = e.renderNextNavButton,
        E = void 0 === N || N,
        w = c[b],
        L = je("uitk-carousel-button-paging", "uitk-carousel-button-prev"),
        C = je("uitk-carousel-button-paging", "uitk-carousel-button-next"),
        I = p.useRef(null),
        R = p.useRef(null),
        S = "undefined" != typeof window && "ontouchstart" in window ? 50 : 0,
        _ = n && (0, Se.__assign)({
          localAnalyticsId: "".concat(r, ".Carousel.").concat(Fe.clickLeft)
        }, n),
        A = n && (0, Se.__assign)({
          localAnalyticsId: "".concat(r, ".Carousel.").concat(Fe.clickRight)
        }, n),
        M = function (e) {
          e && e.current && e.current.focus();
        },
        U = (0, _e.debounce)(S, function () {
          h && h(), i && (null == l ? void 0 : l.current) ? l.current.scrollLeft - .75 * l.current.getBoundingClientRect().width <= 0 && M(I) : w > 0 && 1 === o && M(I);
        }),
        T = (0, _e.debounce)(S, function () {
          if (m && m(), i && (null == l ? void 0 : l.current)) {
            var e = l.current,
              t = e.scrollLeft,
              n = e.scrollWidth,
              a = e.clientWidth;
            t + .75 * l.current.getBoundingClientRect().width >= n - a && M(R);
          } else w > 0 && o === s - w - 1 && M(R);
        }),
        B = p.useCallback(function (e) {
          y ? "ArrowLeft" === e.key ? T() : "ArrowRight" === e.key && U() : "ArrowLeft" === e.key ? U() : "ArrowRight" === e.key && T();
        }, [y, T, U]);
      return p.useEffect(function () {
        if (d) return document.body.addEventListener("keydown", B), function () {
          document.body.removeEventListener("keydown", B);
        };
      }, [d, B]), t = je("uitk-carousel-controls", !k && E && "show-next-button-only", !E && k && "show-prev-button-only"), p.createElement("div", {
        className: t
      }, k && p.createElement(ne.UitkPagingPrevButton, {
        analytics: _,
        className: L,
        iconId: null == u ? void 0 : u.prev,
        iconTitle: a.prevButton,
        onClick: v && i ? void 0 : U,
        domRef: R,
        "data-stid": "carousel-nav-prev",
        "aria-label": a.prevButton,
        tabIndex: 0,
        pagingOverlay: f
      }), E && p.createElement(ne.UitkPagingNextButton, {
        analytics: A,
        className: C,
        iconId: null == u ? void 0 : u.next,
        iconTitle: a.nextButton,
        onClick: v && i ? void 0 : T,
        domRef: I,
        "data-stid": "carousel-nav-next",
        "aria-label": a.nextButton,
        tabIndex: 0,
        pagingOverlay: f
      }));
    };
  ze.displayName = "UitkCarouselNav";
  var Fe,
    Oe = x.classNames.bind(Me());
  !function (e) {
    e.clickLeft = "clickLeft", e.clickRight = "clickRight", e.scrollLeft = "scrollLeft", e.scrollRight = "scrollRight";
  }(Fe || (Fe = {}));
  var Ve = function (e) {
      var t = e.analytics,
        n = e.buttonText,
        a = e.carouselHeaderLevel,
        r = e.carouselHeaderText,
        i = e.carouselHeaderVisible,
        o = e.carouselName,
        l = e.carouselRef,
        s = e.children,
        c = e.className,
        d = e.domRef,
        u = e.fullSheetVisible,
        m = e.hideNav,
        h = void 0 !== m && m,
        f = e.innerSpacing,
        g = e.itemsGap,
        v = void 0 === g ? {
          sm: 16,
          md: 16,
          lg: 16
        } : g,
        b = e.itemsVisible,
        y = void 0 === b ? {
          sm: 1,
          md: 2,
          lg: 3,
          xl: 4
        } : b,
        k = e.itemsMaxHeight,
        N = void 0 !== k && k,
        E = e.l10n,
        w = e.naturalWidthItems,
        L = void 0 !== w && w,
        C = e.navigationIconId,
        I = void 0 === C ? {
          next: "next-button",
          prev: "prev-button"
        } : C,
        R = e.onChange,
        S = e.onIndexChange,
        _ = e.pagingInset,
        A = void 0 !== _ && _,
        M = e.pagingOverlay,
        U = void 0 !== M && M,
        T = e.pagingPersistent,
        B = e.peek,
        P = void 0 !== B && B,
        j = e.peekAmount,
        z = void 0 === j ? {
          sm: 48,
          md: 16,
          lg: 32
        } : j,
        F = e.startIndex,
        O = void 0 === F ? 0 : F,
        V = e.stretchToFill,
        D = void 0 === V || V,
        $ = e.useContainerSizing,
        G = void 0 === $ || $,
        W = e.wrapItems,
        H = void 0 === W || W,
        q = p.useState(!1),
        Y = q[0],
        X = q[1],
        K = p.useState(0),
        Q = K[0],
        Z = K[1],
        J = p.useState(!1),
        ee = J[0],
        te = J[1],
        ne = p.useState(!1),
        ae = ne[0],
        re = ne[1],
        ie = p.useState("sm"),
        oe = ie[0],
        le = ie[1],
        se = p.useState(16),
        ce = se[0],
        de = se[1],
        ue = p.useState(48),
        me = ue[0],
        he = ue[1],
        pe = p.useState(0),
        fe = pe[0],
        ge = pe[1],
        ve = p.useState(!1),
        be = ve[0],
        ye = ve[1],
        xe = p.useState(!1),
        ke = xe[0],
        Ne = xe[1],
        Ee = p.useState({
          PARTIAL: !1,
          FULL: !1
        }),
        we = Ee[0],
        Le = Ee[1],
        Ce = p.useState(0),
        Ie = Ce[0],
        Re = Ce[1],
        Ae = p.useState(!1),
        Me = Ae[0],
        Te = Ae[1],
        Be = p.useRef(!1),
        je = p.useRef(!1),
        Ve = p.useRef(!1),
        De = p.useRef(!1),
        $e = p.useRef(!1),
        Ge = p.useRef(null),
        We = p.useRef(null),
        He = p.useRef([]),
        qe = p.useRef(0),
        Ye = p.useRef(!0),
        Xe = p.Children.count(s),
        Ke = null != d ? d : Ge,
        Qe = y[oe],
        Ze = !L && 1 === Qe && !P,
        Je = P && z && f,
        et = function (e) {
          return ae && 0 !== e ? -1 * e : e;
        },
        tt = p.useRef([]),
        nt = p.useReducer(function (e, t) {
          var n = t.payload,
            a = n.itemIndex,
            r = n.snapPoint,
            i = ae ? function () {
              var t,
                n = null === (t = e.find(function (e) {
                  return e.itemIndex === a - 1;
                })) || void 0 === t ? void 0 : t.snapPoint;
              return 0 === a ? fe || 0 : r + ce + (n || 0);
            }() : Math.floor(r);
          return -1 !== e.findIndex(function (e) {
            return e.itemIndex === n.itemIndex;
          }) ? e.map(function (e, t) {
            return t === a ? (0, Se.__assign)((0, Se.__assign)({}, e), {
              snapPoint: i
            }) : e;
          }) : (n.snapPoint = i, (0, Se.__spreadArray)((0, Se.__spreadArray)([], e, !0), [n], !1));
        }, []),
        at = nt[0],
        rt = nt[1],
        it = p.useReducer(function (e, t) {
          var n = t.payload;
          return -1 !== e.findIndex(function (e) {
            return e.itemIndex === n.itemIndex;
          }) ? e.map(function (e, t) {
            return t === n.itemIndex ? (0, Se.__assign)((0, Se.__assign)({}, e), {
              inView: n.inView
            }) : e;
          }).sort(function (e, t) {
            return e.itemIndex - t.itemIndex;
          }) : (0, Se.__spreadArray)((0, Se.__spreadArray)([], e, !0), [n], !1).sort(function (e, t) {
            return e.itemIndex - t.itemIndex;
          });
        }, []),
        ot = it[0],
        lt = it[1],
        st = p.useReducer(function (e, t) {
          var n = t.payload;
          return (-1 === e.findIndex(function (e) {
            return e.itemIndex === n.itemIndex;
          }) ? (0, Se.__spreadArray)((0, Se.__spreadArray)([], e, !0), [n], !1) : e).sort(function (e, t) {
            return e.itemIndex - t.itemIndex;
          });
        }, []),
        ct = st[0],
        dt = st[1],
        ut = function (e) {
          if (tt.current.length > 0) {
            for (var t = tt.current.length, n = Object.values(tt.current).map(function (e) {
                return e.snapPoint;
              }), a = 0, r = t - 1; a < r;) Math.abs(n[a] - e) <= Math.abs(n[r] - e) ? r -= 1 : a += 1;
            return n.indexOf(n[a]);
          }
          return 0;
        },
        mt = function () {
          var n = function (n) {
            He.current[n] || (He.current[n] = !0, "function" == typeof e.itemViewedCallback && e.itemViewedCallback(n), t && (0, x.analyticsTracker)(t, "".concat(o, ".Carousel.itemViewed.").concat(n), ""));
          };
          if (L) ct.forEach(function (e) {
            n(e.itemIndex);
          });else {
            var a = Qe;
            P && (a += 1);
            for (var r = 0; r < a && Q + r < p.Children.count(s); ++r) n(Q + r);
          }
        },
        ht = p.useCallback(function (e) {
          t && (0, x.analyticsTracker)(t, "".concat(o, ".Carousel.").concat(e ? Fe.scrollRight : Fe.scrollLeft), "");
        }, [t, o]),
        pt = function (e) {
          if (We.current) {
            if (Ze) {
              var t = We.current.getBoundingClientRect().width,
                n = Math.abs(e);
              return Math.round(n / t);
            }
            return ut(e);
          }
          return 0;
        },
        ft = function () {
          var e = We.current;
          if (e) {
            var t = e.scrollLeft,
              n = e.clientWidth,
              a = e.scrollWidth - n - 1;
            Ne(et(t) >= a);
          }
        },
        gt = function (e) {
          var t;
          if (We.current) {
            !De.current && Te(!0);
            var n = We.current,
              a = et(n.scrollLeft),
              r = e - a,
              i = function (o) {
                t || (t = o);
                var l = function (e, t, n, a) {
                    var r = e >= 350 || $e.current,
                      i = r ? t : n + a * function (e) {
                        return e < .5 ? 2 * Math.pow(e, 2) : 1 - Math.pow(-2 * e + 2, 2) / 2;
                      }(e / 350);
                    return {
                      done: r,
                      position: i
                    };
                  }(o - t, e, a, r),
                  s = l.done,
                  c = l.position;
                n.scrollLeft = et(Ze ? e : c), s || Ze ? (ft(), Te(!1), !je.current && ht(r > 0)) : window.requestAnimationFrame(i);
              };
            De.current ? (n.scrollLeft = et(e), ft(), X(!0), De.current = !1) : window.requestAnimationFrame(i), qe.current = e;
          }
        },
        vt = p.useCallback((0, _e.debounce)(200, function () {
          var e, t, n;
          if (Ve.current) Ve.current = !1;else if (Be.current) Be.current = !1;else if (De.current = !1, We.current) {
            var a = et(We.current.scrollLeft);
            a > qe.current ? Ye.current = !0 : Ye.current = !1;
            var r = a - qe.current > 0;
            if (ht(r), qe.current = a, je.current) je.current = !1;else {
              var i = L ? (e = a, We.current ? ut(e) : 0) : pt(a),
                o = Ze ? i : (t = Xe - Qe, (n = function (e) {
                  return !0 === Ye.current ? e + 1 : e;
                }(i)) > t ? t : n);
              Z(o);
            }
            ft();
          }
        }), [oe, ae]),
        bt = p.useCallback(function (e) {
          e.key && (Be.current = !0, Ve.current = !1);
        }, [oe, ae]);
      p.useEffect(function () {
        return document.body.addEventListener("keydown", bt), function () {
          document.body.removeEventListener("keydown", bt);
        };
      }, [bt]);
      var yt = function (e) {
          var t, n;
          if (!P || Je) return (null === (t = at[e]) || void 0 === t ? void 0 : t.snapPoint) - fe;
          if (P && !Je) {
            var a = Qe > 1 ? (me + ce) / 2 - fe : 0;
            return (null === (n = at[e]) || void 0 === n ? void 0 : n.snapPoint) - a;
          }
        },
        xt = function () {
          var e = null == We ? void 0 : We.current;
          if (window && Re(window.innerWidth), e) {
            var t = getComputedStyle(e).getPropertyValue("--size") || "sm";
            "xl" !== t || y.xl || (t = "lg"), t && function (e) {
              var t = L ? 12 : v && v[e],
                n = f && f[e],
                a = P && z && z[e],
                r = n ? a + n : a;
              t && de(Number((0, x.MakeEgdsSizingLength)(t, !1))), r && he(Number((0, x.MakeEgdsSizingLength)(r, !1))), n && ge(Number((0, x.MakeEgdsSizingLength)(n, !1)));
            }(t), le(t), be || ye(!0);
          }
        },
        kt = function (e) {
          var t, n;
          if (je.current = !1, De.current = !1, L) {
            var a = We.current;
            if (a) {
              var r = .75 * a.getBoundingClientRect().width,
                i = et(a.scrollLeft),
                o = a.clientWidth,
                l = a.scrollWidth - o - 2 * fe,
                s = 1 === e ? i + r : i - r,
                c = 1 === e && s > l,
                d = ut(s),
                u = ut(l) + 1;
              c ? (Z(u), !ke && 1 === e && gt(null === (t = at[u]) || void 0 === t ? void 0 : t.snapPoint)) : Z(d);
            }
          } else {
            var m = Qe,
              h = 1 === e ? Q + Number(m) : Q - Number(m),
              p = Xe - Qe;
            h < 0 ? h = 0 : h >= p && (h = p), Z(h), h !== p || ke || 1 !== e || gt(null === (n = at[h]) || void 0 === n ? void 0 : n.snapPoint);
          }
          Be.current = !0;
        },
        Nt = function () {
          kt(-1);
        },
        Et = function () {
          kt(1);
        },
        wt = function (e) {
          var t;
          if (Be.current = !0, L && We.current) {
            var n = We.current,
              a = n.clientWidth,
              r = n.scrollWidth;
            t = ut(r - a - 2 * fe) + 1;
          } else t = Xe - Qe;
          Z(e < 0 ? 0 : e >= t ? t : e);
        };
      p.useEffect(function () {
        if (Y && function () {
          if (We.current) {
            var e = We.current.querySelectorAll('\n          .uitk-carousel-item:not([aria-hidden="true"]) h1:not([aria-hidden="true"]),\n          .uitk-carousel-item:not([aria-hidden="true"]) h2:not([aria-hidden="true"]),\n          .uitk-carousel-item:not([aria-hidden="true"]) h3:not([aria-hidden="true"]),\n          .uitk-carousel-item:not([aria-hidden="true"]) h4:not([aria-hidden="true"]),\n          .uitk-carousel-item:not([aria-hidden="true"]) h5:not([aria-hidden="true"]),\n          .uitk-carousel-item:not([aria-hidden="true"]) h6:not([aria-hidden="true"])\n        '),
              t = Array.from(e).map(function (e) {
                return e.innerText || e.textContent;
              }),
              n = ot.filter(function (e) {
                return e.inView;
              }).map(function (e) {
                return e.itemIndex + 1;
              });
            L ? setTimeout(function () {
              (0, x.liveAnnounce)(E.formatText("carousel.indexAndTotal", n.join(", "), Xe, ""), x.Level.POLITE);
            }, 200) : t.length > 0 ? setTimeout(function () {
              (0, x.liveAnnounce)(E.formatText("carousel.cardChange", t.join(", ")), x.Level.POLITE);
            }, 200) : setTimeout(function () {
              (0, x.liveAnnounce)(E.formatText("gallerycarousel.imageChange", Q + 1, Xe, ""), x.Level.POLITE);
            }, 200);
          }
        }(), be && we.FULL && mt(), Be.current) {
          je.current = !1, Be.current = !1, Ve.current = !0;
          var e = yt(Q);
          gt(e);
        }
      }, [we.FULL, Q, ot, ct, be]), p.useEffect(function () {
        S && S(Q);
      }, [Q]), p.useEffect(function () {
        tt.current = at;
      }, [at]), p.useEffect(function () {
        xt(), !O && We.current && (We.current.scrollLeft = 0), O ? (De.current = !0, wt(O)) : X(!0), "ontouchstart" in window && te(!0), "rtl" === document.querySelector("html").getAttribute("dir") && re(!0), (0, x.liveAnnounce)(""), be && we.FULL && mt();
      }, [be]), p.useEffect(function () {
        window && Re(window.innerWidth);
        var e = (0, _e.debounce)(200, function () {
          Ie !== window.innerWidth && (Re(window.innerWidth), xt());
        });
        return window.addEventListener("resize", e), function () {
          return window.removeEventListener("resize", e);
        };
      }, [oe, Q]), p.useEffect(function () {
        var e = window && window.matchMedia("(prefers-reduced-motion: reduce)");
        $e.current = !e || e.matches, e.addEventListener("change", function () {
          $e.current = e.matches;
        });
      }, []), p.useEffect(function () {
        var e;
        if (!L && !De.current) {
          var t = et(null === (e = null == We ? void 0 : We.current) || void 0 === e ? void 0 : e.scrollLeft),
            n = pt(t);
          if (n > 0 && at) {
            je.current = !0;
            var a = yt(n);
            a && (Z(n), gt(a));
          }
        }
      }, [oe, Ie, at]), p.useEffect(function () {
        R && R(We);
      }), p.useEffect(function () {
        var e = new IntersectionObserver(function (e) {
            e.forEach(function (e) {
              Le({
                PARTIAL: e.isIntersecting,
                FULL: 1 === e.intersectionRatio
              });
            });
          }, {
            threshold: [0, 1],
            root: null
          }),
          t = We.current;
        return t && e.observe(t), function () {
          t && e.unobserve(t);
        };
      }, []);
      var Lt = p.useMemo(function () {
          return {
            isNaturalWidthItemsCarousel: L,
            carouselWindowWidth: Ie,
            carouselSize: oe,
            setSnapPointItem: rt,
            setNaturalWidthItemsInView: lt,
            setNaturalWidthItemsViewed: dt,
            isRtl: ae,
            carouselIsVisible: we.PARTIAL
          };
        }, [L, Ie, ae, oe, we.PARTIAL]),
        Ct = p.useMemo(function () {
          return (0, x.MakeEgdsSizingLength)(v[oe]);
        }, [oe, v]),
        It = p.useMemo(function () {
          return {
            sm: z.sm + ((null == f ? void 0 : f.sm) || 0),
            md: z.md + ((null == f ? void 0 : f.md) || 0),
            lg: z.lg + ((null == f ? void 0 : f.lg) || 0),
            xl: z.xl ? z.xl + ((null == f ? void 0 : f.xl) || 0) : z.lg + ((null == f ? void 0 : f.lg) || 0)
          };
        }, [z, f]),
        Rt = p.useCallback(function (e, t, n) {
          void 0 === n && (n = !0);
          var a = {};
          return Object.keys(t).forEach(function (r) {
            var i = t[r],
              o = n ? "".concat((0, x.MakeEgdsSizingLength)(i)) : i;
            a["--uitk-carousel-".concat(e, "-").concat(r)] = o;
          }), a;
        }, []),
        St = p.useCallback(function () {
          return Ze ? "0px" : L ? "".concat(12, "px") : Ct;
        }, [Ct, Ze, L]);
      return p.useImperativeHandle(l, function () {
        return {
          changeIndex: function (e) {
            return wt(e);
          }
        };
      }), function () {
        var e,
          l = Oe("uitk-carousel", (!P || !(Qe < Xe)) && "no-peek", !A && "no-inset", !ee && "no-touch", N && "items-max-height", Ze && "full-image-gallery-type", f && "has-inner-spacing", T && "has-persistent-nav", c, oe && "undefined" != typeof window ? oe : "sm"),
          d = Oe("uitk-carousel-container", Ze && "full-image-gallery-type", ($e.current || De.current) && "no-animation-on-scroll", L && "has-natural-width-items", G && "use-container-sizing"),
          m = {
            analytics: t,
            buttonText: n,
            carouselName: o,
            currentIndex: Q,
            itemCount: Xe,
            itemsVisible: y,
            fullSheetVisible: u,
            navigationIconId: I,
            onNextCb: Et,
            onPrevCb: Nt,
            pagingOverlay: U,
            scrollEventOngoing: Me,
            size: oe,
            isRtl: ae,
            naturalWidthItems: L,
            carouselContainerRef: We,
            renderPrevNavButton: Q > 0,
            renderNextNavButton: Ze ? Q < Xe - 1 : !ke
          },
          g = a && Ue.get(a) || Ue.get("h3"),
          b = function () {
            if (!L) return Xe > Qe;
            var e = null == We ? void 0 : We.current;
            if (e) {
              var t = e.getBoundingClientRect().width,
                n = e.scrollWidth;
              return Math.ceil(t) < n;
            }
          }(),
          k = (0, Se.__assign)((0, Se.__assign)({
            "--uitk-carousel-items-gap": St()
          }, f && (0, Se.__assign)({
            "--uitk-carousel-inner-spacing": "".concat(fe, "px")
          }, Rt("inner-spacing", f))), !Ze && !L && (0, Se.__assign)((0, Se.__assign)((0, Se.__assign)({}, Rt("items-gap", v)), Rt("peek-amount", It)), Rt("item-count", y, !1)));
        return p.createElement(x.UitkContextProvider, {
          config: {
            context: "uitk-carousel-context",
            data: Lt
          }
        }, p.createElement("div", {
          className: l,
          ref: Ke,
          "data-stid": "carousel-wrapper"
        }, r && p.createElement(g, {
          className: Oe((e = {}, e["is-visually-hidden"] = !i, e))
        }, r), p.createElement("div", {
          className: d,
          "aria-label": r,
          ref: We,
          onScroll: vt,
          "data-stid": "carousel-container",
          style: k,
          tabIndex: 0
        }, p.createElement(Pe, {
          itemsVisible: y,
          size: oe,
          currentIndex: Q,
          l10n: E,
          peek: P,
          wrapItems: !(!L && !Ze) || H,
          itemCount: Xe,
          stretchToFill: D
        }, s)), !h && b && p.createElement(ze, (0, Se.__assign)({}, m))));
      }();
    },
    De = function (e) {
      var t = (0, _.useLocalization)();
      return p.createElement(Ve, (0, Se.__assign)({
        l10n: t
      }, e));
    };
  De.displayName = "UitkCarousel";
  const $e = g.p + "./styles/egds-lodging-carousel.css",
    Ge = x.classNames.bind($e),
    We = _a => {
      var {
          children: e,
          extraPeekWidth: t = !1
        } = _a,
        n = __rest(_a, ["children", "extraPeekWidth"]);
      const a = Ge({
        "carousel-extra-peek": t
      });
      return (0, y.jsx)(De, Object.assign(Object.assign({
        className: a
      }, n), {
        children: e
      }));
    };
  We.displayName = "LodgingCarousel";
  var He = g(263),
    qe = g.n(He),
    Ye = (new Map([["top", "block-start"], ["right", "inline-end"], ["bottom", "block-end"], ["left", "inline-start"]]), new Map([["blockstart", "block-start"], ["blockend", "block-end"], ["inlinestart", "inline-start"], ["inlineend", "inline-end"]]), new Map([["article", "article"], ["aside", "aside"], ["div", "div"], ["footer", "footer"], ["header", "header"], ["section", "section"], ["ul", "ul"], ["ol", "ol"], ["li", "li"]])),
    Xe = (new Map([["dark", "dark"], ["light", "light"]]), new Map([["r1-1", "ratio-1-1"], ["r1-2", "ratio-1-2"], ["r1-3", "ratio-1-3"], ["r1-4", "ratio-1-4"], ["r1-5", "ratio-1-5"], ["r1-6", "ratio-1-6"]]), new Map([["r1-1", "ratio-1-1"], ["r1-2", "ratio-1-2"], ["r1-3", "ratio-1-3"], ["r1-4", "ratio-1-4"], ["r1-5", "ratio-1-5"], ["r1-6", "ratio-1-6"]])),
    Ke = (new Map([["top-right", "top-right"], ["top-left", "top-left"], ["bottom-right", "bottom-right"], ["bottom-left", "bottom-left"], ["all", "all"]]), new Map([["h2", "h2"], ["h3", "h3"], ["h4", "h4"], ["h5", "h5"], ["h6", "h6"], ["p", "p"]]), {
      PRIMARY: "primary",
      SECONDARY: "secondary",
      HIGHLIGHT: "highlight",
      GLOBAL_LOYALTY_STANDARD: "global-loyalty-standard",
      GLOBAL_LOYALTY_LOW: "global-loyalty-low",
      GLOBAL_LOYALTY_MIDDLE: "global-loyalty-middle",
      GLOBAL_LOYALTY_HIGH: "global-loyalty-high",
      GLOBAL_LOYALTY_EXTRAHIGH: "global-loyalty-extra-high"
    }),
    Qe = x.classNames.bind(qe()),
    Ze = p.forwardRef(function (e, t) {
      var n,
        a,
        r,
        i,
        o,
        l,
        s = e.backgroundTheme,
        c = void 0 === s ? Ke.PRIMARY : s,
        d = e.border,
        u = e.children,
        m = e.className,
        h = e.overflow,
        f = e.padded,
        g = e.placeholder,
        v = e.selected,
        b = e.tag,
        y = e.style,
        k = (0, Se.__rest)(e, ["backgroundTheme", "border", "children", "className", "overflow", "padded", "placeholder", "selected", "tag", "style"]),
        N = [],
        E = b && Ye.get(b) || Ye.get("div"),
        w = p.Children.toArray(u);
      p.Children.forEach(u, function (e) {
        var t;
        if (e) switch (null === (t = e.type) || void 0 === t ? void 0 : t.displayName) {
          case "UitkCardActionArea":
            r = e;
            break;
          case "UitkCardFeaturedHeader":
            i = e;
            break;
          case "UitkCardLink":
            o = e;
            break;
          case "UitkCardPlaceholder":
            l = e;
            break;
          default:
            N.push(e);
        }
      });
      var L,
        C = "uitk-card",
        I = g && Xe.get(g.aspectRatio),
        R = c && (L = c, Object.values(Ke).includes(L)) ? c : Ke.PRIMARY,
        S = Qe(C, "".concat(C, "-roundcorner-all"), r && "".concat(C, "-has-action-area"), d && "".concat(C, "-has-border"), g && "".concat(C, "-has-placeholder-border"), i && "".concat(C, "-has-featured-header"), o && "".concat(C, "-has-link"), h && "".concat(C, "-has-overflow"), f && "".concat(C, "-padded"), v && "".concat(C, "-selected"), !u && "".concat(C, "-empty"), m, g && "".concat(C, "-").concat(I), "".concat(C, "-has-").concat(R, "-theme"));
      if (l) return p.cloneElement(l, {
        className: S
      });
      if (w.length > 1) return p.createElement(E, (0, Se.__assign)({
        className: S
      }, k, {
        ref: t,
        style: y
      }), i, N, r, o);
      if (1 === w.length) {
        var _ = w[0],
          A = (0, Se.__assign)((0, Se.__assign)({}, null === (n = null == _ ? void 0 : _.props) || void 0 === n ? void 0 : n.style), y);
        return p.cloneElement(_, (0, Se.__assign)((0, Se.__assign)({
          className: (0, x.classNames)(S, null === (a = null == _ ? void 0 : _.props) || void 0 === a ? void 0 : a.className)
        }, k), 0 !== Object.keys(A).length && {
          style: A
        }));
      }
      return p.createElement(E, (0, Se.__assign)({
        className: S
      }, k, {
        ref: t,
        style: y
      }));
    });
  Ze.displayName = "UitkCard";
  const Je = g.p + "./styles/egds-lodging-card.css",
    et = x.classNames.bind(Je),
    tt = _a => {
      var {
          children: e,
          underlineTitleOnHover: t = !1,
          addBorderOnHover: n = !1,
          removeRoundedCorner: a = !1,
          className: r
        } = _a,
        i = __rest(_a, ["children", "underlineTitleOnHover", "addBorderOnHover", "removeRoundedCorner", "className"]);
      const o = et({
          "add-border-on-hover": n,
          "uitk-card-unset-roundcorner-all": a
        }, r),
        l = p.default.useRef();
      return (0, p.useEffect)(() => {
        var _a;
        const e = (_a = l === null || l === void 0 ? void 0 : l.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".uitk-heading");
        e && e.length > 0 && e[0] && t && e[0].classList.add("underline-title-on-hover");
      }, [t]), (0, y.jsx)(Ze, Object.assign(Object.assign({
        className: o,
        ref: l
      }, i), {
        children: e
      }));
    };
  tt.displayName = "LodgingCard";
  const nt = g.p + "./styles/egds-lodging-range-indicator.css",
    at = x.classNames.bind(nt),
    rt = "range-indicator",
    it = ({
      percentage: e,
      key: t,
      badge: n,
      segmentNumber: a
    }) => {
      const r = (0, p.useRef)(null),
        i = (0, p.useRef)(null);
      return (0, p.useEffect)(() => {
        if (r && r.current && i && i.current) {
          const t = r.current.getBoundingClientRect().width / 2,
            n = i.current.parentElement.getBoundingClientRect().width,
            o = a > 0 && (100 - e) / 100 * n < t;
          0 === a && e / 100 * n < t && (r.current.style.transform = `translateX(calc(${t}px - var(--uitk-layoutgrid-egds-size__1x)))`), o && (r.current.style.transform = `translateX(calc(${-1 * t}px + var(--uitk-layoutgrid-egds-size__1x)))`);
        }
      }), (0, y.jsxs)("div", {
        className: at(`${rt}-indicator`),
        style: {
          insetInlineStart: `calc(${e}% - var(--uitk-layoutgrid-egds-size__6x))`
        },
        ref: i,
        children: [(0, y.jsx)("div", {
          className: at(`${rt}-badge`),
          ref: r,
          children: (0, y.jsx)(Ne.UitkBadgeStandard, {
            a11yText: n.accessibility,
            text: n.text,
            theme: "emphasis",
            size: "large"
          })
        }), (0, y.jsx)(E.UitkIcon, {
          className: at(`${rt}-dot`),
          name: "circle_filled",
          size: E.UitkIconSize.EXTRA_SMALL
        })]
      }, t);
    },
    ot = new Map([["REGULAR", "regular"], ["MEDIUM", "medium"], ["BOLD", "bold"]]),
    lt = new Map([["EMPHASIS", "EMPHASIS"]]),
    st = new Map([["NEGATIVE", "negative"], ["NEUTRAL", "neutral"], ["POSITIVE", "positive"], ["VERY_POSITIVE", "very-positive"]]),
    ct = x.classNames.bind(nt),
    dt = ({
      accessibility: e,
      className: t,
      milestones: n,
      segments: a
    }) => {
      const r = "range-indicator",
        i = lt.get("EMPHASIS"),
        o = a.map(({
          style: e
        }) => e === i ? 4 : 2),
        l = o.reduce((e, t) => e + t, 0);
      return (0, y.jsxs)("figure", {
        "aria-label": e,
        className: ct(r, t),
        role: "figure",
        children: [e && (0, y.jsx)("figcaption", {
          className: "is-visually-hidden",
          children: e
        }), (0, y.jsxs)(N.UitkLayoutGrid, {
          className: ct(`${r}-grid`),
          columns: l,
          children: [a.map(({
            pins: e,
            theme: t
          }, n) => (0, y.jsx)(N.UitkLayoutGridItem, {
            colSpan: o[n],
            children: (0, y.jsx)("div", {
              className: ct(`${r}-segment`, {
                [`${r}-segment__${st.get(t)}`]: t
              }),
              children: e && e.map(({
                percentage: e,
                badge: t
              }, r) => (0, y.jsx)(it, {
                badge: t,
                percentage: e,
                segmentNumber: n + 1 === a.length || 0 === n ? n : null
              }, r))
            })
          }, n)), n.slice(0, o.length - 1).map(({
            label: e
          }, t) => {
            const {
                text: n,
                weight: a
              } = e,
              r = o.slice(0, t + 1).reduce((e, t) => e + t, 0);
            return (0, y.jsx)(N.UitkLayoutGridItem, {
              colStart: r,
              colEnd: r + 2,
              children: (0, y.jsx)(H.UitkText, {
                align: "center",
                size: 200,
                weight: ot.get(a),
                children: n
              })
            }, t);
          })]
        })]
      });
    };
  dt.displayName = "EGDSLocalRangeIndicator";
  var ut,
    mt,
    ht,
    pt = g(935),
    ft = g.n(pt),
    gt = {
      LEADING: "leading",
      TRAILING: "trailing"
    },
    vt = (new Map([[1, "1"], [2, "2"], [3, "3"], [4, "4"], [6, "6"], [8, "8"], [12, "12"]]), -1),
    bt = function (e) {
      e && e.current && e.current.focus();
    },
    yt = function (e) {
      e && e.current && (ut = e.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'));
    },
    xt = function (e, t, n) {
      yt(e), t && ut.length ? ut && ut[n ? 1 : 0].focus() : bt(e);
    },
    kt = function () {
      ut[ut.length - 2].focus();
    },
    Nt = function () {
      ut[1].focus();
    },
    Et = function (e) {
      var t = p.Children.toArray(e);
      return {
        get hasCloseButton() {
          return !!this.closeButtonElem;
        },
        get hasAlignment() {
          var e, t, n;
          return !!this.hasCloseButton && (null !== (n = null === (t = null === (e = this.closeButtonElem) || void 0 === e ? void 0 : e.props) || void 0 === t ? void 0 : t.alignment) && void 0 !== n ? n : "right");
        },
        get layoutProps() {
          return this.hasCloseButton && {
            space: "two",
            direction: "top" === this.hasAlignment ? "column" : "row-reverse"
          };
        },
        get closeButtonLayoutProps() {
          return this.hasCloseButton && "top" === this.hasAlignment && {
            alignSelf: "end"
          };
        },
        closeButtonElem: t.find(function (e) {
          var t;
          return "UitkSheetCloseButton" === (null === (t = e.type) || void 0 === t ? void 0 : t.displayName);
        }),
        footerElem: t.find(function (e) {
          var t;
          return "UitkSheetFooter" === (null === (t = e.type) || void 0 === t ? void 0 : t.displayName);
        }),
        childrenElem: t.filter(function (e) {
          var t, n;
          return !(null === (t = e.type) || void 0 === t ? void 0 : t.displayName) || !["UitkSheetCloseButton", "UitkSheetFooter"].includes(null === (n = e.type) || void 0 === n ? void 0 : n.displayName);
        })
      };
    },
    wt = function (e, t) {
      var n,
        a = null == t ? void 0 : t.closest("button"),
        r = a && (null == a ? void 0 : a.className.includes("clear"));
      return !!(null === (n = null == e ? void 0 : e.current) || void 0 === n ? void 0 : n.contains(t)) || r;
    },
    Lt = function (e) {
      var t = mt.disableBodyClickHandler,
        n = mt.triggerRef,
        a = mt.onDismiss,
        r = e.target;
      e.target.shadowRoot && (r = e.composedPath()[0]), (null == n ? void 0 : n.current) === r || t || wt(ht, r) || wt(n, r) || a && a();
    },
    Ct = function (e) {
      var t = mt.disableArrowKeyHandler,
        n = mt.onDismiss;
      if ("ArrowDown" === e.key || "ArrowUp" === e.key) {
        if (t) return;
        var a = document.activeElement;
        if (a instanceof HTMLSelectElement || a instanceof HTMLInputElement && "number" === a.type) return;
        e.preventDefault();
      }
      "Escape" === e.key && n && n();
    },
    It = function (e) {
      var t,
        n = mt.disableArrowKeyHandler,
        a = mt.onDismiss,
        r = mt.triggerRef,
        i = ht;
      if (e.shiftKey && "Tab" === e.key && (t = document.activeElement, (null == r ? void 0 : r.current) === e.target)) return !1;
      if (i.current) if (yt(ht), "ArrowDown" === e.key) {
        if (n) return;
        if (t = document.activeElement, (null == r ? void 0 : r.current) === e.target) return void ut[vt = 0].focus();
        (o = ut[vt + 1]) && (vt += 1, o.focus());
      } else if ("ArrowUp" === e.key) {
        if (n) return;
        if (t = document.activeElement, (null == r ? void 0 : r.current) === e.target) return !1;
        var o;
        (o = ut[vt - 1]) && (vt -= 1, o.focus());
      } else if ("Tab" === e.key) {
        t = document.activeElement, e.target.shadowRoot && (t = e.composedPath()[0]);
        for (var l = 0; l <= ut.length; l++) t === ut[l] && (vt = l);
        wt(i, t) || a && a();
      }
    },
    Rt = function (e) {
      return Object.values(gt).includes(e);
    },
    St = function (e) {
      var t = "has-uitk-sheet",
        n = document.body.classList;
      return "add" === e ? n.add(t) : n.remove(t);
    },
    _t = x.classNames.bind(ft()),
    At = function (e) {
      var t,
        n,
        a = e.autoFocus,
        r = void 0 === a || a,
        i = e.children,
        o = e.className,
        l = e.fullWidth,
        s = void 0 !== l && l,
        c = e.hasModal,
        d = e.isExpanded,
        u = e.returnFocusOnClose,
        m = void 0 === u || u,
        h = e.isVisible,
        f = e.triggerRef,
        g = e.type,
        v = void 0 === g ? "bottom" : g,
        b = e.height,
        y = (0, Se.__rest)(e, ["autoFocus", "children", "className", "fullWidth", "hasModal", "isExpanded", "returnFocusOnClose", "isVisible", "triggerRef", "type", "height"]),
        N = p.useRef(null),
        E = "uitk-".concat(v, "-sheet"),
        w = _t(E, ((t = {})["".concat(E, "-full-width")] = s, t["".concat(E, "-expanded")] = d, t), o),
        L = (0, Se.__assign)({}, b && ((n = {})["--uitk-bottom-sheet-height"] = "".concat((0, x.MakeEgdsSizingLength)(b)), n));
      p.useEffect(function () {
        r && h && xt(N, !0, c), c && St("add");
      }, [r, h, c, d]), p.useEffect(function () {
        return function () {
          m && bt(f), c && St("remove");
        };
      }, [c, h, m, f]);
      var C = Et(i),
        I = C.hasCloseButton,
        R = C.layoutProps,
        S = C.closeButtonLayoutProps,
        _ = C.closeButtonElem,
        A = C.childrenElem;
      return p.createElement("section", (0, Se.__assign)({
        ref: N,
        className: w,
        tabIndex: -1,
        style: L
      }, y), c && p.createElement("div", {
        tabIndex: 0,
        onFocus: kt,
        "aria-hidden": "true"
      }), I && p.createElement(k.UitkLayoutFlex, (0, Se.__assign)({}, R), p.createElement(k.UitkLayoutFlexItem, (0, Se.__assign)({}, S), p.createElement("div", null, _)), A && p.createElement(k.UitkLayoutFlexItem, null, A)), !I && A, c && p.createElement("div", {
        tabIndex: 0,
        onFocus: Nt,
        "aria-hidden": "true"
      }));
    };
  At.displayName = "UitkBottomSheet";
  var Mt = x.classNames.bind(ft()),
    Ut = function (e) {
      var t,
        n = e.autoFocus,
        a = void 0 === n || n,
        r = e.children,
        i = e.className,
        o = e.hasModal,
        l = e.isVisible,
        s = e.overflow,
        c = e.returnFocusOnClose,
        d = void 0 === c || c,
        u = e.sideSheetLayout,
        m = e.triggerRef,
        h = e.type,
        f = void 0 === h ? "side" : h,
        g = p.useRef(null),
        v = "uitk-".concat(f, "-sheet");
      p.useEffect(function () {
        a && l && xt(g, !0, o), o && St("add");
      }, [a, o, l]), p.useEffect(function () {
        return function () {
          d && bt(m), o && St("remove");
        };
      }, [d, m]);
      var b = Et(r),
        y = b.hasCloseButton,
        x = b.layoutProps,
        N = b.closeButtonLayoutProps,
        E = b.closeButtonElem,
        w = b.childrenElem,
        L = b.footerElem,
        C = Mt(v, u && function (e, t) {
          var n = e;
          "position" in e || (n.position = "trailing");
          var a = Object.entries(n).map(function (e) {
            var n = e[0],
              a = e[1];
            return "".concat(t, "-").concat(n, "-").concat(a);
          }).join(" ");
          return a;
        }(u, v), ((t = {})["".concat(v, "-position-trailing")] = !u, t["".concat(v, "-has-overflow")] = s, t), i);
      return p.createElement("section", {
        ref: g,
        className: C,
        tabIndex: -1
      }, o && p.createElement("div", {
        tabIndex: 0,
        onFocus: kt
      }), y && p.createElement(k.UitkLayoutFlex, (0, Se.__assign)({}, x), p.createElement(k.UitkLayoutFlexItem, (0, Se.__assign)({}, N), E), p.createElement(k.UitkLayoutFlexItem, null, w)), !y && w, L, o && p.createElement("div", {
        tabIndex: 0,
        onFocus: Nt
      }));
    };
  Ut.displayName = "UitkSideSheet";
  var Tt = p.createContext({
      maxHeight: void 0
    }),
    Bt = x.classNames.bind(ft()),
    Pt = function (e) {
      var t,
        n,
        a,
        r,
        i,
        o,
        l,
        s,
        c = e.autoFocus,
        d = void 0 === c || c,
        u = e.autoPosition,
        m = void 0 === u || u,
        h = e.children,
        f = e.className,
        g = e.fullWidth,
        v = void 0 !== g && g,
        b = e.hasModal,
        y = e.intersectionObserverRoot,
        N = e.isVisible,
        E = e.maxHeight,
        w = e.position,
        L = void 0 === w ? {
          block: gt.TRAILING,
          inline: gt.LEADING
        } : w,
        C = e.applyBlockStartMargin,
        I = void 0 !== C && C,
        R = e.showOverTrigger,
        S = void 0 !== R && R,
        _ = e.returnFocusOnClose,
        A = void 0 === _ || _,
        M = e.triggerRef,
        U = e.type,
        T = void 0 === U ? "popover" : U,
        B = e.width,
        P = L.block && Rt(L.block) ? L.block : gt.TRAILING,
        j = L.inline && Rt(L.inline) ? L.inline : gt.LEADING,
        z = p.useState({
          x: 0,
          y: 0
        }),
        F = z[0],
        O = z[1],
        V = p.useState(!1),
        D = V[0],
        $ = V[1],
        G = p.useRef({
          x: 0,
          y: 0
        }),
        W = p.useRef(null),
        H = p.useRef(null),
        q = "uitk-".concat(T, "-sheet"),
        Y = Bt(q, f, "".concat(q, "-inline-pos-").concat(j), "".concat(q, "-block-pos-").concat(P), ((t = {})["".concat(q, "-full-width")] = v, t), ((n = {})["".concat(q, "-open")] = N, n), ((a = {})["".concat(q, "-has-intersection-root-el")] = m && y, a), ((r = {})["".concat(q, "-has-block-start-margin")] = P === gt.TRAILING && I, r)),
        X = p.useCallback(function () {
          m && W.current && s && s.unobserve(W.current);
        }, [m, s]),
        K = p.useCallback(function () {
          var e = "undefined" != typeof document ? document.documentElement : null;
          if ((null == W ? void 0 : W.current) && e) {
            var t = W.current,
              n = window.innerHeight,
              a = t.getBoundingClientRect(),
              r = e.getBoundingClientRect(),
              i = 0,
              o = 0;
            a.right > r.right ? i = -Math.abs(Math.ceil(a.right) - Math.ceil(r.right)) : a.left < r.left && (i = Math.abs(a.left)), P === gt.TRAILING && a.bottom > n ? o = -Math.abs(Math.ceil(a.bottom) - Math.ceil(n)) : P === gt.LEADING && a.top < 0 && (o = Math.abs(Math.ceil(a.top))), (i || o) && (t.style.setProperty("--uitk-popover-sheet-offset-translate-x", "".concat(i, "px")), t.style.setProperty("--uitk-popover-sheet-offset-translate-y", "".concat(o, "px"))), X();
          }
        }, [P, X]),
        Q = function (e) {
          e.forEach(function (e) {
            e.intersectionRatio < .99 && e.intersectionRatio > 0 && function (e) {
              var t = G.current,
                n = Math.ceil(e.boundingClientRect.right) > Math.ceil(e.intersectionRect.right),
                a = Math.ceil(e.boundingClientRect.left) < Math.ceil(e.intersectionRect.left),
                r = Math.ceil(e.boundingClientRect.bottom) > Math.ceil(e.intersectionRect.bottom),
                i = Math.ceil(e.boundingClientRect.top) < Math.ceil(e.intersectionRect.top);
              if (n) {
                var o = Math.ceil(e.boundingClientRect.right) - Math.ceil(e.intersectionRect.right);
                O({
                  x: -Math.abs(t.x - o),
                  y: t.y
                });
              } else a && (o = e.boundingClientRect.left - e.intersectionRect.left, O({
                x: t.x - o,
                y: t.y
              }));
              if (r || i) {
                var l = Math.ceil(e.boundingClientRect.right) - Math.ceil(e.intersectionRect.right),
                  s = e.boundingClientRect.left - e.intersectionRect.left,
                  c = t.x;
                if (a ? c = t.x - s : n && (c = -Math.abs(t.x - l)), P === gt.TRAILING && r) {
                  var d = Math.ceil(e.boundingClientRect.bottom) - Math.ceil(e.intersectionRect.bottom);
                  O({
                    x: c,
                    y: -Math.abs(t.y - d)
                  });
                } else P === gt.LEADING && i && (d = Math.ceil(e.boundingClientRect.top) - Math.ceil(e.intersectionRect.top), O({
                  x: c,
                  y: t.y - d
                }));
              }
            }(e);
          });
        },
        Z = p.useCallback(function () {
          if (!window || !window.IntersectionObserver) return !1;
          y && (H.current = document.querySelector(y));
          for (var e = [], t = 0; t <= 1; t += .01) e.push(t);
          var n = {
              threshold: e
            },
            a = y ? Object.assign(n, {
              root: H.current
            }) : n;
          s || (s = new IntersectionObserver(Q, a)), W.current && s.observe(W.current);
        }, [y]);
      p.useEffect(function () {
        N && (function (e, t) {
          var n = document.body;
          mt = e, ht = t, n.addEventListener("click", Lt, {
            capture: !0
          }), n.addEventListener("keydown", Ct), n.addEventListener("keyup", It);
        }(e, W), m && Z());
      }, [d, m, Z, N, b, W, e]), p.useEffect(function () {
        d && N && xt(W, !1, !1);
      }, [d, N]), p.useEffect(function () {
        G.current = F;
      }, [F]), p.useEffect(function () {
        D && K();
      }, [D, K]), p.useEffect(function () {
        return document.addEventListener("scroll", X), function () {
          document.removeEventListener("scroll", X);
        };
      }, [X]), p.useEffect(function () {
        var e, t, n;
        N || (document.removeEventListener("scroll", X), n = document.body, vt = -1, n.removeEventListener("click", Lt, {
          capture: !0
        }), n.removeEventListener("keydown", Ct), n.removeEventListener("keyup", It), X(), O({
          x: 0,
          y: 0
        }), $(!1), null === (e = null == W ? void 0 : W.current) || void 0 === e || e.style.removeProperty("--uitk-popover-sheet-offset-translate-x"), null === (t = null == W ? void 0 : W.current) || void 0 === t || t.style.removeProperty("--uitk-popover-sheet-offset-translate-y"), A && bt(M));
      }, [N, X, A, M]);
      var J = Et(h),
        ee = J.hasCloseButton,
        te = J.layoutProps,
        ne = J.closeButtonLayoutProps,
        ae = J.closeButtonElem,
        re = J.childrenElem,
        ie = (0, Se.__assign)((0, Se.__assign)((0, Se.__assign)((0, Se.__assign)({}, (null == M ? void 0 : M.current) && M.current.offsetParent && (null == W ? void 0 : W.current) && (0, Se.__assign)((0, Se.__assign)(((i = {})["--uitk-popover-sheet-block-pos"] = "".concat(P === gt.LEADING ? M.current.offsetTop - (W.current.offsetHeight - (S ? M.current.offsetHeight : 0)) : M.current.offsetTop + (S ? 0 : M.current.offsetHeight), "px"), i), j === gt.LEADING && ((o = {})["--uitk-popover-sheet-inline-pos-ltr"] = "".concat(M.current.offsetLeft, "px"), o["--uitk-popover-sheet-inline-pos-rtl"] = "".concat(M.current.offsetParent.offsetWidth - M.current.offsetWidth - M.current.offsetLeft, "px"), o)), j === gt.TRAILING && ((l = {})["--uitk-popover-sheet-inline-pos-ltr"] = "".concat(M.current.offsetLeft + M.current.offsetWidth - W.current.offsetWidth, "px"), l["--uitk-popover-sheet-inline-pos-rtl"] = "".concat(M.current.offsetParent.offsetWidth - M.current.offsetWidth - M.current.offsetLeft - (W.current.offsetWidth - M.current.offsetWidth), "px"), l))), B && {
          inlineSize: "".concat((0, x.MakeEgdsSizingLength)(B))
        }), F && {
          "--uitk-popover-sheet-grow-x": "".concat(F.x, "px"),
          "--uitk-popover-sheet-grow-y": "".concat(F.y, "px")
        }), m && H.current && {
          "--uitk-popover-sheet-max-inline-size": "".concat(H.current.clientWidth, "px")
        });
      return p.createElement(Tt.Provider, {
        value: {
          maxHeight: E
        }
      }, p.createElement("section", {
        "data-testid": "popover-sheet",
        ref: W,
        className: Y,
        tabIndex: -1,
        style: ie,
        onAnimationEnd: function (e) {
          !D && e.animationName.match(/sheet-grow-/) && $(!0);
        }
      }, ee && p.createElement(k.UitkLayoutFlex, (0, Se.__assign)({}, te), p.createElement(k.UitkLayoutFlexItem, (0, Se.__assign)({}, ne), p.createElement("div", null, ae)), re && p.createElement(k.UitkLayoutFlexItem, null, re)), !ee && re));
    };
  Pt.displayName = "UitkPopoverSheet";
  var jt = x.classNames.bind(ft()),
    zt = function (e) {
      var t = e.ariaLabel,
        n = e.autoFocus,
        a = void 0 === n || n,
        r = e.children,
        i = e.className,
        o = e.returnFocusOnClose,
        l = void 0 === o || o,
        s = e.isVisible,
        c = e.triggerRef,
        d = e.theme,
        u = void 0 === d ? "standard" : d,
        m = e.type,
        h = void 0 === m ? "full" : m,
        f = p.useRef(null),
        g = "uitk-".concat(h, "-sheet"),
        v = jt(g, i, "".concat(g, "-").concat(u));
      p.useEffect(function () {
        a && s && xt(f, !0, !0), s && St("add");
      }, [a, s]), p.useEffect(function () {
        return function () {
          l && bt(c), St("remove");
        };
      }, [l, c]);
      var b = Et(r),
        y = b.hasCloseButton,
        x = b.layoutProps,
        N = b.closeButtonLayoutProps,
        E = b.closeButtonElem,
        w = b.childrenElem;
      return p.createElement("section", {
        ref: f,
        className: v,
        tabIndex: -1,
        role: "dialog",
        "aria-label": t
      }, p.createElement("div", {
        tabIndex: 0,
        onFocus: kt,
        "aria-hidden": "true"
      }), y && p.createElement(k.UitkLayoutFlex, (0, Se.__assign)({}, x), p.createElement(k.UitkLayoutFlexItem, (0, Se.__assign)({}, N), p.createElement("div", null, E)), w && p.createElement(k.UitkLayoutFlexItem, null, w)), !y && w, p.createElement("div", {
        tabIndex: 0,
        onFocus: Nt,
        "aria-hidden": "true"
      }));
    };
  zt.displayName = "UitkFullSheet";
  var Ft = x.classNames.bind(ft()),
    Ot = function (e) {
      var t,
        n = e.ariaLabel,
        a = e.autoFocus,
        r = void 0 === a || a,
        i = e.children,
        o = e.className,
        l = e.isVisible,
        s = e.centeredSheetSize,
        c = void 0 === s ? "medium" : s,
        d = e.height,
        u = e.returnFocusOnClose,
        m = void 0 === u || u,
        h = e.triggerRef,
        f = e.type,
        g = void 0 === f ? "centered" : f,
        v = p.useRef(null),
        b = "uitk-".concat(g, "-sheet"),
        y = Ft(b, o, "small" === c ? "uitk-centered-sheet-small" : "uitk-centered-sheet-medium"),
        N = (0, Se.__assign)({}, d && ((t = {})["--uitk-centered-sheet-height"] = "".concat((0, x.MakeEgdsSizingLength)(d)), t));
      p.useEffect(function () {
        yt(v);
      }, []), p.useEffect(function () {
        r && l && xt(v, !0, !0), l && St("add");
      }, [r, l]), p.useEffect(function () {
        return function () {
          m && bt(h), St("remove");
        };
      }, [m, h]);
      var E = Et(i),
        w = E.hasCloseButton,
        L = E.layoutProps,
        C = E.closeButtonLayoutProps,
        I = E.closeButtonElem,
        R = E.childrenElem;
      return p.createElement("section", {
        ref: v,
        className: y,
        tabIndex: -1,
        role: "dialog",
        "aria-modal": !0,
        "aria-label": n,
        style: N
      }, p.createElement("div", {
        tabIndex: 0,
        onFocus: function () {
          yt(v), kt();
        },
        "aria-hidden": "true"
      }), w && p.createElement(k.UitkLayoutFlex, (0, Se.__assign)({}, L), p.createElement(k.UitkLayoutFlexItem, (0, Se.__assign)({}, C), p.createElement("div", null, I)), R && p.createElement(k.UitkLayoutFlexItem, null, R)), !w && R, p.createElement("div", {
        tabIndex: 0,
        onFocus: function () {
          yt(v), Nt();
        },
        "aria-hidden": "true"
      }));
    };
  Ot.displayName = "UitkCenteredSheet";
  var Vt = x.classNames.bind(ft()),
    Dt = function (e) {
      var t,
        n = e.autoFocus,
        a = void 0 === n || n,
        r = e.children,
        i = e.className,
        o = e.isVisible,
        l = void 0 !== o && o,
        s = e.liveAnnounceString,
        c = e.type,
        d = void 0 === c ? "bottom" : c,
        u = Vt(i, "uitk-sheet");
      switch (d) {
        case "bottom":
        default:
          t = At;
          break;
        case "centered":
          t = Ot;
          break;
        case "full":
          t = zt;
          break;
        case "popover":
          t = Pt;
          break;
        case "side":
          t = Ut;
      }
      return p.useEffect(function () {
        var e;
        l && (e = s, (0, x.liveAnnounce)(e, x.Level.POLITE));
      }, [l, s]), p.createElement(t, (0, Se.__assign)({}, e, {
        className: u,
        autoFocus: a
      }), r);
    },
    $t = function (e) {
      var t = (0, _.useLocalization)();
      return p.createElement(Dt, (0, Se.__assign)({
        l10n: t
      }, e));
    };
  $t.displayName = "UitkSheet";
  const Gt = (e => {
    var t = {};
    return g.d(t, e), t;
  })({
    CSSTransition: () => h.CSSTransition
  });
  var Wt = x.classNames.bind(ft()),
    Ht = function (e) {
      var t,
        n,
        a = e.children,
        r = e.closeCallback,
        i = e.isVisible,
        o = void 0 !== i && i,
        l = e.openCallback,
        s = "uitk-sheet";
      switch (a.props.type) {
        case "popover":
          t = 180, n = 60;
          break;
        case "side":
          t = 200, n = 120;
          break;
        default:
          t = 275, n = 275;
      }
      return p.createElement(Gt.CSSTransition, {
        classNames: {
          enter: Wt("".concat(s, "-enter")),
          enterActive: Wt("".concat(s, "-enter-active")),
          exit: Wt("".concat(s, "-exit")),
          exitActive: Wt("".concat(s, "-exit-active"))
        },
        in: o,
        unmountOnExit: !0,
        timeout: {
          enter: t,
          exit: n
        },
        onEntered: l,
        onExited: r
      }, a);
    };
  Ht.displayName = "UitkSheetTransition";
  const qt = g.p + "./styles/egds-lodging-sheet.css",
    Yt = x.classNames.bind(qt),
    Xt = "expando-bottom-sheet",
    Kt = "centered-sheet-width",
    Qt = "split-view",
    Zt = e => Math.round(e / 4) / 4 + "rem",
    Jt = {
      large: [(0, N.MinMax)("660px", "800px"), (0, N.MinMax)("332px", "400px")],
      extra_large: [(0, N.MinMax)("680px", "864px"), (0, N.MinMax)("520px", "1fr")]
    },
    en = e => e ? e.getBoundingClientRect() : new DOMRect(),
    tn = _a => {
      var {
          className: e,
          children: t,
          transition: n,
          tall: a,
          expanded: r,
          minWidth: i,
          maxWidth: o,
          splitView: l,
          columns: s = Jt,
          onDimensionsChange: c
        } = _a,
        d = __rest(_a, ["className", "children", "transition", "tall", "expanded", "minWidth", "maxWidth", "splitView", "columns", "onDimensionsChange"]);
      const u = "bottom" === d.type && "boolean" == typeof r,
        m = "centered" === d.type && Boolean(i || o),
        h = Yt(e, {
          "sheet-tall": "bottom" === d.type && a,
          [`${Xt}-collapsed`]: u && !r,
          [Kt]: m,
          "split-view-sheet": l
        }),
        f = (0, p.useMemo)(() => {
          if (m) return Object.assign(Object.assign({}, i ? {
            "--centered-sheet-width-min-size": Zt(i)
          } : {}), o ? {
            "--centered-sheet-width-max-size": Zt(o)
          } : {});
        }, [i, o]),
        g = (0, p.useRef)(null),
        v = (0, p.useCallback)(e => {
          g.current = e, c === null || c === void 0 ? void 0 : c(en(e));
        }, [c]),
        {
          openCallback: b,
          closeCallback: x
        } = n !== null && n !== void 0 ? n : {},
        k = (0, p.useCallback)(() => {
          requestAnimationFrame(() => {
            c === null || c === void 0 ? void 0 : c(en(g.current));
          }), b === null || b === void 0 ? void 0 : b();
        }, [b, c]),
        E = (0, p.useCallback)(() => {
          requestAnimationFrame(() => {
            c === null || c === void 0 ? void 0 : c(en(g.current));
          }), x === null || x === void 0 ? void 0 : x();
        }, [x, c]),
        w = (0, p.useCallback)(() => {
          c === null || c === void 0 ? void 0 : c(en(g.current));
        }, [c]);
      (0, p.useEffect)(() => {
        if (c) {
          const e = () => {
            c === null || c === void 0 ? void 0 : c(en(g.current));
          };
          return window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
        }
      }, [c]);
      let L = (0, y.jsx)($t, Object.assign(Object.assign({}, d), {
        className: h,
        children: t
      }));
      return n && (L = (0, y.jsx)(Ht, Object.assign(Object.assign({}, n), {
        openCallback: k,
        closeCallback: E,
        children: L
      }))), u && (L = (0, y.jsx)(Gt.CSSTransition, {
        in: r,
        timeout: 300,
        classNames: {
          enter: Yt(`${Xt}-enter`),
          enterActive: Yt(`${Xt}-enter-active`),
          exit: Yt(`${Xt}-exit`),
          exitActive: Yt(`${Xt}-exit-active`)
        },
        appear: !1,
        onEntered: w,
        onExited: w,
        children: L
      })), m && (L = (0, y.jsx)("div", {
        style: f,
        className: `${Kt}-provider`,
        children: L
      })), c && (L = (0, y.jsx)("div", {
        className: "dimensions-change",
        ref: v,
        children: L
      })), l && (L = (0, y.jsx)("div", {
        className: Qt,
        children: (0, y.jsxs)(N.UitkLayoutGrid, {
          columns: s,
          className: `${Qt}-grid`,
          children: [(0, y.jsx)(N.UitkLayoutGridItem, {
            className: `${Qt}-grid-item`,
            children: (0, y.jsx)("div", {
              children: L
            })
          }), (0, y.jsx)(N.UitkLayoutGridItem, {
            children: (0, y.jsx)("div", {})
          })]
        })
      })), L;
    };
  var nn,
    an = new Map([["cover", "fit-cover"], ["contain", "fit-contain"]]),
    rn = new Map([["all", "all"], ["max", "max"], ["startstart", "startstart"], ["startend", "startend"], ["endstart", "endstart"], ["endend", "endend"]]),
    on = g(481),
    ln = g.n(on),
    sn = x.classNames.bind(ln());
  !function (e) {
    e.R1_1 = "ratio-1-1", e.R4_3 = "ratio-4-3", e.R3_2 = "ratio-3-2", e.R16_9 = "ratio-16-9", e.R21_9 = "ratio-21-9", e.R3_4 = "ratio-3-4", e.R4_1 = "ratio-4-1";
  }(nn || (nn = {}));
  var cn = function (e) {
    function t() {
      return null !== e && e.apply(this, arguments) || this;
    }
    return (0, Se.__extends)(t, e), t.prototype.render = function () {
      var e,
        t = this.props,
        n = t.className,
        a = t.children,
        r = t.ratio,
        i = t.src,
        o = t.roundcorner,
        l = t.imageFit,
        s = t.additionalProps,
        c = t.style,
        d = i ? "div" : "figure",
        u = function (e, t, n) {
          t.forEach(function (t) {
            return e.push("".concat(n, "-").concat(rn.get(t)));
          });
        },
        m = sn("uitk-image", n, o && function (e) {
          var t = "uitk-image-roundcorner",
            n = typeof e,
            a = [],
            r = Array.isArray(e);
          if ("boolean" === n) a.push("".concat(t, "-all"));else if (r) u(a, e, t);else {
            var i = e;
            Object.getOwnPropertyNames(i).forEach(function (e) {
              var n = "".concat(t, "-").concat(e);
              if (Array.isArray(i[e])) u(a, i[e], n);else {
                var r = i[e];
                Object.getOwnPropertyNames(r).forEach(function (e) {
                  "set" === r[e] ? a.push("".concat(n, "-").concat(rn.get(e))) : "unset" === r[e] && a.push("".concat(n, "-").concat(rn.get(e), "-unset"));
                });
              }
            });
          }
          return a;
        }(o), l && "uitk-image-".concat(an.get(l)), ((e = {})["uitk-image-".concat(r, " uitk-image-ratio")] = (0, x.validatePropType)(r, nn), e["uitk-image-ratio-2-1 uitk-image-ratio"] = !r, e["uitk-image-background"] = i, e)),
        h = {};
      c ? h = c : i && (h = {
        backgroundImage: 'url("'.concat(i, '")')
      });
      var f = (0, Se.__assign)({
        className: m,
        style: h
      }, s);
      return p.createElement(d, (0, Se.__assign)({}, f), a);
    }, t.displayName = "UitkFigure", t.AspectRatio = nn, t;
  }(p.Component);
  const dn = g.p + "./styles/egds-lodging-thumbnail-card.css",
    un = x.classNames.bind(dn),
    mn = _a => {
      var {
          children: e,
          className: t,
          placeholder: n,
          imageUrl: a
        } = _a,
        r = __rest(_a, ["children", "className", "placeholder", "imageUrl"]);
      const i = un("card-thumbnail", {
        "uitk-card-has-placeholder-border": n
      }, t);
      return (0, y.jsx)(Ze, Object.assign(Object.assign({
        className: i
      }, r), {
        children: a ? (0, y.jsx)(cn, {
          src: a,
          imageFit: "cover",
          children: e
        }) : e
      }));
    };
  mn.displayName = "ThumbnailCard";
  var hn,
    pn,
    fn = new Map([["div", "div"], ["header", "header"], ["section", "section"]]),
    gn = new Map([["close", "close"], ["back", "arrow_back"], ["expand_up", "expand_less"], ["expand_down", "expand_more"]]),
    vn = new Map([["h1", "h1"], ["h2", "h2"], ["h3", "h3"], ["h4", "h4"], ["h5", "h5"], ["h6", "h6"]]),
    bn = new Map([["standard", "standard"], ["transparent", "transparent"]]),
    yn = g(187),
    xn = g.n(yn),
    kn = x.classNames.bind(xn()),
    Nn = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, Se.__extends)(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.id,
          n = e.className,
          a = e.children,
          r = e.tag,
          i = r && fn.get(r) || fn.get("div"),
          o = kn("uitk-toolbar", n);
        return p.createElement(k.UitkLayoutFlex, {
          id: t,
          alignItems: "center",
          className: o,
          tag: i
        }, a);
      }, t.displayName = "UitkToolbarContainer", t.defaultProps = {
        tag: "div"
      }, t;
    }(p.Component),
    En = x.classNames.bind(xn()),
    wn = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, Se.__extends)(t, e), t.prototype.render = function () {
        var e,
          t,
          n = this.props,
          a = n.disabled,
          r = n.onClick,
          i = n.buttonRef,
          o = n.onClickAnalytics,
          l = n.buttonId,
          s = n.expandedState,
          c = n.containerId,
          d = n.children,
          u = o && (0, Se.__assign)({
            localAnalyticsId: "Close"
          }, o);
        p.Children.forEach(d, function (n) {
          var a;
          n && ("UitkIcon" !== (null === (a = null == n ? void 0 : n.type) || void 0 === a ? void 0 : a.displayName) || e ? "string" != typeof n || t || (t = n) : e = n);
        });
        var m = "".concat(Cn.baseClassName, "-button-v2"),
          h = "".concat(m, "-content"),
          f = En(m, !t && "".concat(m, "-icon-only"), t && "".concat(m, "-has-label")),
          g = En(h, !t && "".concat(h, "-icon-only"), t && "".concat(h, "-has-label"));
        return p.createElement(k.UitkLayoutFlexItem, {
          className: f,
          shrink: 0
        }, p.createElement("button", {
          type: "button",
          disabled: a,
          onClick: r,
          onClickCapture: x.analyticsTracker.bind(this, u),
          ref: i,
          id: l,
          "aria-expanded": s === pn.EXPANDED,
          "aria-controls": c
        }, p.createElement("span", {
          className: g
        }, e, t && p.createElement("span", {
          className: En("".concat(h, "-label"))
        }, t))));
      }, t.displayName = "UitkToolbarButton", t;
    }(p.Component),
    Ln = x.classNames.bind(xn());
  !function (e) {
    e.OVERLAY = "Overlay";
  }(hn || (hn = {})), function (e) {
    e.EXPANDED = "expanded", e.COLLAPSED = "collapsed";
  }(pn || (pn = {}));
  var Cn = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.state = {
          elevatedToolbar: !1
        }, n.isElevatedToolbar = !1, n.handleScroll = (0, _e.throttle)(100, n.handleScroll.bind(n)), n;
      }
      return (0, Se.__extends)(t, e), t.prototype.componentDidUpdate = function () {
        var e = this.props.contentDomRef;
        e && e.current && "function" == typeof e.current.addEventListener && e.current.addEventListener("scroll", this.handleScroll);
      }, t.prototype.componentWillUnmount = function () {
        var e = this.props.contentDomRef;
        e && e.current && "function" == typeof e.current.removeEventListener && e.current.removeEventListener("scroll", this.handleScroll);
      }, t.prototype.handleScroll = function (e) {
        e.target.scrollTop > 0 ? this.isElevatedToolbar || this.toggleElevatedState(!0) : this.toggleElevatedState(!1);
      }, t.prototype.toggleElevatedState = function (e) {
        var t = this;
        this.setState({
          elevatedToolbar: e
        }, function () {
          t.isElevatedToolbar = e;
        });
      }, t.prototype.render = function () {
        var e,
          n = this.props,
          a = n.id,
          r = n.className,
          i = n.toolbarType,
          o = n.children,
          l = n.childClassName,
          s = n.navigationContent,
          c = n.toolbarActionContent,
          d = n.toolbarTitle,
          u = n.toolbarTitleTag,
          m = n.toolbarSubtitle,
          h = this.state.elevatedToolbar,
          f = Ln(r, i && "transparent" === bn.get(i) && "uitk-toolbar-transparent", {
            elevated: h,
            "has-placeholder": o
          }),
          g = u && vn.get(u) || vn.get("h2"),
          v = d ? p.createElement(g, {
            className: Ln("".concat(t.baseClassName, "-title-content"))
          }, d) : null,
          b = Ln("".concat(t.baseClassName, "-subtitle-content")),
          y = m && ("string" == typeof m ? p.createElement("p", {
            className: b
          }, m) : p.cloneElement(m, {
            className: b
          })),
          x = s || {},
          N = x.navType,
          w = x.navIconLabel,
          L = x.navButtonLabel,
          C = x.onClick,
          I = x.onClickAnalytics,
          R = x.navButtonRef,
          S = x.navButtonId,
          _ = N && gn.get(N) || gn.get("close");
        return "expand_down" === N && (e = pn.EXPANDED), "expand_up" === N && (e = pn.COLLAPSED), p.createElement(Nn, {
          id: a,
          className: f
        }, s && C && p.createElement(wn, {
          onClick: C,
          onClickAnalytics: I,
          buttonId: S,
          buttonRef: R,
          expandedState: null != e ? e : void 0,
          containerId: e ? a : void 0
        }, p.createElement(E.UitkIcon, {
          id: "".concat(S, "-").concat(_, "-toolbar"),
          name: _,
          size: E.UitkIconSize.MEDIUM,
          title: w
        }), L), p.createElement(k.UitkLayoutFlexItem, {
          grow: 1,
          className: Ln("truncate")
        }, p.createElement("section", null, v, m && y)), c, o && p.createElement(k.UitkLayoutFlexItem, {
          className: Ln(l),
          minWidth: "full_width"
        }, p.createElement("section", null, o)));
      }, t.displayName = "UitkToolbar", t.baseClassName = "uitk-toolbar", t;
    }(p.Component),
    In = x.classNames.bind(xn()),
    Rn = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }
      return (0, Se.__extends)(t, e), t.prototype.render = function () {
        var e = this.props,
          t = e.elevation,
          n = e.className,
          a = (0, Se.__rest)(e, ["elevation", "className"]),
          r = "";
        "flat" === t ? r = "".concat(Cn.baseClassName, "-").concat(t) : "floating" === t && (r = "".concat(t));
        var i = In(r, n);
        return p.createElement(Cn, (0, Se.__assign)({
          className: i
        }, a));
      }, t.displayName = "UitkStandardToolbar", t;
    }(p.Component);
  const Sn = g.p + "./styles/egds-lodging-toolbar.css",
    _n = x.classNames.bind(Sn),
    An = e => {
      const {
          bottomBorder: t,
          className: n
        } = e,
        a = _n(n, {
          "toolbar-border-bottom": t
        });
      return (0, y.jsx)(Rn, Object.assign({
        className: a
      }, e));
    };
  var Mn = g(877),
    Un = g.n(Mn),
    Tn = x.classNames.bind(Un()),
    Bn = function (e) {
      function t(t) {
        var n = e.call(this, t) || this;
        return n.useReducedMotion = !1, n.state = {
          checked: t.checked
        }, n.handleChange = n.handleChange.bind(n), n;
      }
      return (0, Se.__extends)(t, e), t.getDerivedStateFromProps = function (e, t) {
        return e.checked !== t.checked ? {
          checked: e.checked
        } : null;
      }, t.prototype.componentDidMount = function () {
        this.useReducedMotion = "function" == typeof window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      }, t.prototype.handleChange = function (e) {
        var t = this.props.onChange,
          n = this.state.checked;
        this.setState({
          checked: !n
        }), t && t(e);
      }, t.prototype.render = function () {
        var e,
          t = this,
          n = this.props,
          a = n.className,
          r = n.children,
          i = n.description,
          o = n.disabled,
          l = n.errorMessage,
          s = n.id,
          c = n.indeterminate,
          d = n.labelClassName,
          u = n.labelSuffix,
          m = n.name,
          h = n.required,
          f = n.value,
          g = n.defaultChecked,
          v = n.a11yLabel,
          b = n.domRef,
          y = this.state.checked;
        y && g && console.error("Both checked and defaultChecked prop can`t be set it as true");
        var N = g ? "defaultChecked" : "checked",
          w = g || y,
          L = "uitk-checkbox",
          C = Tn(L, {
            "is-disabled": o
          }),
          I = Tn("uitk-checkbox-label", ((e = {})[d] = Boolean(d), e["uitk-checkbox-label-haslabelsuffix"] = u, e["is-required"] = h, e)),
          R = Tn({
            checked: y
          }),
          S = Tn("uitk-checkbox-icon"),
          _ = Tn("".concat(L, "-control")),
          A = Tn("".concat(L, "-content")),
          M = Tn("".concat(L, "-label-content")),
          U = Tn("".concat(L, "-label-suffix")),
          T = Tn("".concat(L, "-description uitk-type-200")),
          B = Tn("".concat(L, "-error")),
          P = [_, Tn("".concat(L, "-has-reduced-motion"))],
          j = r,
          z = v || [j, u, i].filter(function (e) {
            return !!e;
          }).toString();
        return p.createElement(x.UitkContextWrapper, null, function (e, n) {
          var r;
          return p.createElement(k.UitkLayoutFlex, {
            className: C,
            wrap: "nowrap"
          }, p.createElement(k.UitkLayoutFlexItem, {
            shrink: 0,
            className: a
          }, p.createElement("input", (0, Se.__assign)({
            type: "checkbox",
            name: m || s,
            id: s
          }, ((r = {})[N] = w, r), {
            className: R,
            disabled: o,
            onChange: t.handleChange,
            value: f,
            ref: b,
            "aria-describedby": l ? "".concat(s, "-error") : void 0,
            "aria-invalid": !!l || void 0,
            "aria-required": h,
            "aria-checked": c ? "mixed" : void 0,
            "aria-label": z
          }))), p.createElement(k.UitkLayoutFlexItem, {
            className: t.useReducedMotion ? P : _,
            shrink: 0
          }, p.createElement("span", {
            "aria-hidden": "true"
          }, w && p.createElement(E.UitkIcon, {
            name: c ? "remove" : "check",
            className: S
          }))), p.createElement(k.UitkLayoutFlexItem, {
            className: A,
            grow: 1
          }, p.createElement("div", null, p.createElement("label", {
            className: I,
            htmlFor: s
          }, p.createElement("p", {
            className: M
          }, j, h && (null == n ? void 0 : n.hasRequiredFieldIndicator) && p.createElement("span", {
            className: "uitk-checkbox-required-asterisk",
            "aria-hidden": "true"
          }, " ", "*")), u && p.createElement("p", {
            className: U
          }, u), i && p.createElement("p", {
            className: T
          }, i)), l && p.createElement("p", {
            className: B,
            id: "".concat(s, "-error")
          }, l))));
        });
      }, t.displayName = "UitkCheckbox", t.defaultProps = {
        checked: !1
      }, t;
    }(p.Component),
    Pn = g(858),
    jn = g.n(Pn),
    zn = (new Map([["left", "textalign-left"], ["right", "textalign-right"], ["center", "textalign-center"], ["justify", "textalign-justify"], ["justify-all", "textalign-justify-all"], ["start", "textalign-start"], ["end", "textalign-end"], ["match-parent", "textalign-match-parent"]]), new Map([["10%", "size-10-percent"], ["20%", "size-20-percent"], ["30%", "size-30-percent"], ["40%", "size-40-percent"], ["50%", "size-50-percent"], ["60%", "size-60-percent"], ["70%", "size-70-percent"], ["80%", "size-80-percent"], ["90%", "size-90-percent"], ["100%", "size-100-percent"]]), new Map([["baseline", "verticalalign-baseline"], ["sub", "verticalalign-sub"], ["super", "verticalalign-super"], ["text-top", "verticalalign-text-top"], ["text-bottom", "verticalalign-text-bottom"], ["middle", "verticalalign-middle"], ["top", "verticalalign-top"], ["bottom", "verticalalign-bottom"]]), new Map([["odd", "striped-odd"], ["even", "striped-even"]])),
    Fn = (new Map([["inline-scroll", "inline-scroll"]]), new Map([["equal", "col-inlinesize-equal"]]), "th"),
    On = (new Map([["leading", "leading"], ["center", "center"], ["trailing", "trailing"]]), new Map([["top", "top"], ["middle", "middle"], ["bottom", "bottom"]]), "standard"),
    Vn = "graphic",
    Dn = new Map([["ascending", "ascending"], ["descending", "descending"]]),
    $n = new Map([["leading", "leading"], ["trailing", "trailing"]]),
    Gn = (new Map([["headerRow", "headerRow"], ["bodyRow", "bodyRow"]]), new Map([["columnGradient-rowBorder", "columnGradient-rowBorder"], ["columnGradient-rowNoBorder", "columnGradient-rowNoBorder"], ["columnBorder-rowGradient", "columnBorder-rowGradient"], ["columnNoBorder-rowGradient", "columnNoBorder-rowGradient"], ["onlyBorders", "onlyBorders"]]), new Map([["start", "start"], ["end", "end"]])),
    Wn = p.createContext({}),
    Hn = x.classNames.bind(jn()),
    qn = function (e) {
      var t,
        n = e.children,
        a = e.className,
        r = e.frozenRow;
      return p.createElement("tbody", {
        className: Hn(a, (t = {}, t["".concat("uitk-table-body", "-frozen")] = "bodyRow" === r, t))
      }, n);
    };
  qn.displayName = "UitkTableBody";
  var Yn = x.classNames.bind(jn()),
    Xn = function (e) {
      var t = e.align,
        n = e.children,
        a = e.className,
        r = (0, Se.__rest)(e, ["align", "children", "className"]),
        i = "uitk-table-caption",
        o = Yn(i, a, t && "".concat(i, "-").concat(Gn.get(t)));
      return n ? p.createElement("caption", (0, Se.__assign)({
        className: o
      }, r), n) : null;
    };
  Xn.displayName = "UitkTableCaption", Xn.defaultProps = {
    align: Gn.get("start")
  };
  var Kn = x.classNames.bind(jn()),
    Qn = function (e) {
      var t,
        n = e.children,
        a = e.className,
        r = e.frozenRow,
        i = e.frozenRegionsStyle,
        o = (0, Se.__rest)(e, ["children", "className", "frozenRow", "frozenRegionsStyle"]),
        l = "uitk-table-head",
        s = Kn(l, a, ((t = {})["".concat(l, "-frozen")] = "headerRow" === r, t["".concat(l, "-frozen-gradient")] = "headerRow" === r && "columnGradient-rowBorder" !== i && "columnGradient-rowNoBorder" !== i && "onlyBorders" !== i, t["".concat(l, "-frozen-border")] = "headerRow" === r && ("columnGradient-rowBorder" === i || "onlyBorders" === i), t));
      return n ? p.createElement(Wn.Provider, {
        value: {
          tag: Fn
        }
      }, p.createElement("thead", (0, Se.__assign)({
        className: s
      }, o), n)) : null;
    };
  Qn.displayName = "UitkTableHead";
  var Zn = {
      FIXED: "fixed",
      RELATIVE: "relative"
    },
    Jn = x.classNames.bind(jn()),
    ea = p.createContext({}),
    ta = p.forwardRef(function (e, t) {
      var n,
        a,
        r,
        i = e.border,
        o = e.children,
        l = e.className,
        s = e.caption,
        c = e.customHeight,
        d = e.expandableRows,
        u = e.frozenColumn,
        m = e.frozenRow,
        h = e.frozenRegionsStyle,
        f = e.fixedWidthColumns,
        g = e.onSort,
        v = e.onSingleRowSelect,
        b = e.onAllRowsSelect,
        y = e.overflow,
        k = e.isRounded,
        N = e.selectableRows,
        E = e.striped,
        w = e.summary,
        L = e.data,
        C = (0, Se.__rest)(e, ["border", "children", "className", "caption", "customHeight", "expandableRows", "frozenColumn", "frozenRow", "frozenRegionsStyle", "fixedWidthColumns", "onSort", "onSingleRowSelect", "onAllRowsSelect", "overflow", "isRounded", "selectableRows", "striped", "summary", "data"]),
        I = p.useState(L),
        R = I[0],
        S = I[1],
        A = p.useState(""),
        M = A[0],
        U = A[1],
        T = p.useState(""),
        B = T[0],
        P = T[1],
        j = p.useState(!1),
        z = j[0],
        F = j[1],
        O = p.useRef(null),
        V = p.useCallback(function () {
          if (O && O.current && z) {
            var e = O.current.scrollLeft;
            0 === e ? P("start") : e + O.current.offsetWidth >= O.current.scrollWidth ? P("end") : P("middle");
          }
        }, [z]);
      p.useEffect(function () {
        O && O.current && F(O.current.scrollWidth > O.current.clientWidth), V(), S(L);
      }, [L, V]);
      var D = "uitk-table",
        $ = Jn("".concat(D, "-container"), ((n = {})["".concat(D, "-container-overflow-inline-scroll")] = y, n["".concat(D, "-container-scroll-").concat(B)] = z, n["".concat(D, "-container-").concat(u, "-frozen-column")] = u, n)),
        G = Jn(D, ((a = {})["".concat(D, "-border")] = i, a["".concat(D, "-rounded")] = k, a["".concat(D, "-fixed-width-columns")] = f, a), E && "".concat(D, "-").concat(zn.get(E)), l),
        W = (0, _.useLocalization)(),
        H = p.useState([]),
        q = H[0],
        Y = H[1],
        X = p.useState(!1),
        K = X[0],
        Q = X[1],
        Z = function () {
          return q;
        };
      p.useImperativeHandle(t, function () {
        return {
          getSelectedRows: Z
        };
      });
      var J = R && R.columns.map(function (e, t) {
        var n = f && e.width;
        return p.createElement(aa, (0, Se.__assign)({
          tag: Fn,
          key: e.fieldName,
          id: e.fieldName,
          columnWidth: n,
          frozenColumn: ("leading" === u && 0 === t || "trailing" === u && t === R.columns.length - 1) && u,
          frozenRegionsStyle: h
        }, e), e.headerName);
      });
      if (N && Array.isArray(J) && J.length) {
        var ee = (null == q ? void 0 : q.length) === (null === (r = null == R ? void 0 : R.rows) || void 0 === r ? void 0 : r.length) || K;
        null == J || J.unshift(p.createElement(aa, {
          tag: Fn,
          className: Jn("uitk-table-cell-action")
        }, p.createElement(Bn, {
          checked: ee,
          indeterminate: K,
          onChange: function (e) {
            var t = R && (K || e.currentTarget.checked) ? R.rows : [];
            Y(t), Q(!1), null == b || b(t);
          },
          id: "SelectAllRowsCheckbox",
          a11yLabel: !ee || K ? W.formatText("table.select.rows") : W.formatText("table.deselect.rows")
        })));
      }
      var te = function (e, t) {
          var n = null == R ? void 0 : R.rows.filter(function (t) {
              return t.id === e;
            }),
            a = t ? (0, Se.__spreadArray)((0, Se.__spreadArray)([], q, !0), n, !0) : null == q ? void 0 : q.filter(function (t) {
              return e !== t.id;
            });
          Y(a), Q(function (e) {
            var t;
            return e > 0 && e !== (null === (t = null == R ? void 0 : R.rows) || void 0 === t ? void 0 : t.length);
          }(a.length)), null == v || v(a);
        },
        ne = R && R.rows.map(function (e, t) {
          return p.createElement(p.Fragment, null, p.createElement(oa, {
            isChecked: null == q ? void 0 : q.includes(e),
            key: t,
            rowId: e.id,
            isSelectable: N,
            onRowSelect: N ? te : void 0,
            isRowExpandable: d && void 0 !== e.expansionContent,
            checkboxA11yLabel: e.checkboxA11yLabel,
            expandRowA11yLabel: e.expandRowA11yLabel,
            expansionContent: e.expansionContent
          }, R.columns.map(function (t, n) {
            return ("leading" === u && 0 === n || "trailing" === u && n === R.columns.length - 1) && u ? p.createElement(aa, {
              key: t.fieldName,
              id: t.fieldName,
              fixedWidthColumn: f,
              frozenColumn: u,
              frozenRegionsStyle: h
            }, p.isValidElement(e[t.fieldName]), e[t.fieldName]) : p.isValidElement(e[t.fieldName]) ? e[t.fieldName] : p.createElement(aa, {
              key: t.fieldName,
              id: t.fieldName,
              fixedWidthColumn: f
            }, p.isValidElement(e[t.fieldName]), e[t.fieldName]);
          })));
        }),
        ae = R && R.columns.length && p.createElement(p.Fragment, null, p.createElement(Qn, {
          frozenRow: m,
          frozenRegionsStyle: h
        }, p.createElement(oa, null, J)), p.createElement(qn, null, ne)),
        re = u || m ? 0 : -1,
        ie = m && (0, x.validatePropType)(null == c ? void 0 : c.type, Zn) ? {
          blockSize: "".concat(null == c ? void 0 : c.value).concat((null == c ? void 0 : c.type) === Zn.FIXED ? "px" : "vh")
        } : {},
        oe = null != ae ? ae : o;
      return oe ? p.createElement(ea.Provider, {
        value: {
          onSort: function (e, t) {
            U(t.toString()), g && g(e, t);
          },
          sortedColumn: M,
          expandableRows: d,
          colSpan: d && (null == R ? void 0 : R.columns) ? R.columns.length + 1 : null == R ? void 0 : R.columns.length,
          selectableRows: N
        }
      }, p.createElement("div", {
        className: "".concat(D, "-relative-container")
      }, p.createElement("div", {
        ref: O,
        className: $,
        tabIndex: re,
        style: ie,
        onScroll: V
      }, p.createElement("table", (0, Se.__assign)({
        summary: w,
        className: G
      }, C), s && p.createElement(Xn, null, s), oe)))) : null;
    });
  ta.defaultProps = {
    overflow: !0
  }, ta.displayName = "UitkTable";
  var na = x.classNames.bind(jn()),
    aa = function (e) {
      var t,
        n,
        a = p.useContext(Wn),
        r = (0, _.useLocalization)().formatText,
        i = e.align,
        o = e.border,
        l = e.children,
        s = e.className,
        c = e.columnWidth,
        d = e.colSpan,
        u = e.description,
        m = e.isCellExpandable,
        h = e.id,
        f = e.frozenColumn,
        g = e.frozenRegionsStyle,
        v = e.fixedWidthColumn,
        b = e.highlight,
        y = e.onClick,
        k = e.onSort,
        N = e.padding,
        w = e.isSortable,
        L = e.scope,
        C = e.striped,
        I = e.tag,
        R = void 0 === I ? null !== (n = a.tag) && void 0 !== n ? n : "td" : I,
        S = p.useState(),
        A = S[0],
        M = S[1],
        U = p.useContext(ea),
        T = "uitk-table-cell",
        B = R === Fn || a.tag === Fn,
        P = o && (Array.isArray(o) ? (0, Se.__spreadArray)([], o.map(function (e) {
          return "".concat(T, "-border-").concat(e);
        }), !0) : "".concat(T, "-border-").concat(o)),
        j = na(T, P, "".concat(T, "-padding-").concat(N), (null == i ? void 0 : i.horizontal) && "".concat(T, "-align-").concat(i.horizontal), (null == i ? void 0 : i.vertical) && "".concat(T, "-align-").concat(i.vertical), ((t = {})["".concat(T, "-striped")] = C, t["".concat(T, "-header")] = B, t["".concat(T, "-header-sorting")] = w, t["".concat(T, "-header-sorting-").concat(A)] = w && A, t["".concat(T, "-frozen-").concat($n.get(f))] = f, t["".concat(T, "-frozen-").concat($n.get(f), "-gradient")] = f && "columnBorder-rowGradient" !== g && "columnNoBorder-rowGradient" !== g && "onlyBorders" !== g, t["".concat(T, "-frozen-").concat($n.get(f), "-border")] = f && ("columnBorder-rowGradient" === g || "onlyBorders" === g), t["".concat(T, "-fixed-width-column")] = v, t["".concat(T, "-expansion")] = m, t["".concat(T, "-").concat(b)] = b, t), s),
        z = function (e) {
          var t;
          return na("".concat(T, "-icon"), ((t = {})["".concat(T, "-icon-hidden")] = A !== e, t));
        };
      p.useEffect(function () {
        U.sortedColumn && U.sortedColumn !== (null == h ? void 0 : h.toString()) && M(void 0);
      }, [null == U ? void 0 : U.sortedColumn, h]);
      var F = Math.random().toString(36).substring(7),
        O = "aria-label-".concat(F);
      return B && w ? p.createElement(R, {
        className: j,
        style: {
          width: c
        },
        scope: L
      }, p.createElement("button", {
        "aria-label": A === Dn.get("ascending") ? r("table.sort.a11yLabel.descending") : r("table.sort.a11yLabel.ascending"),
        type: "button",
        className: "uitk-table-header-button",
        onClick: function (e) {
          var t;
          if (w) {
            var n = function (e) {
              return e === Dn.get("ascending") ? Dn.get("descending") : Dn.get("ascending");
            };
            null == k || k(n(A), h), null === (t = null == U ? void 0 : U.onSort) || void 0 === t || t.call(U, n(A), h), M(function (e) {
              var t = n(e),
                a = t === Dn.get("ascending") ? r("table.sorted.a11yLabel.ascended") : r("table.sorted.a11yLabel.descended");
              return (0, x.liveAnnounce)(a), t;
            });
          }
          null == y || y(e);
        }
      }, l, !A && p.createElement(E.UitkIcon, {
        size: E.UitkIconSize.EXTRA_SMALL,
        name: "swap_vert"
      }), p.createElement(E.UitkIcon, {
        size: E.UitkIconSize.EXTRA_SMALL,
        name: "sort_ascending",
        className: z(Dn.get("ascending"))
      }), p.createElement(E.UitkIcon, {
        size: E.UitkIconSize.EXTRA_SMALL,
        name: "sort_descending",
        className: z(Dn.get("descending"))
      }))) : p.createElement(R, {
        className: j,
        colSpan: d,
        style: {
          width: B ? c : ""
        },
        scope: B ? L : void 0,
        "aria-describedby": u ? O : void 0
      }, l, p.createElement(function () {
        return u ? p.createElement("span", {
          className: "is-visually-hidden",
          "aria-hidden": !0,
          id: O
        }, u) : p.createElement(p.Fragment, null);
      }, null));
    },
    ra = {
      align: {
        horizontal: "leading",
        vertical: "middle"
      },
      padding: On,
      scope: "col"
    };
  aa.defaultProps = ra, aa.displayName = "UitkTableCell";
  var ia = x.classNames.bind(jn()),
    oa = function (e) {
      var t,
        n = e.children,
        a = e.checkboxA11yLabel,
        r = e.isChecked,
        i = e.className,
        o = e.isRowExpandable,
        l = e.onRowSelect,
        s = e.rowId,
        c = e.isSelectable,
        d = e.expandRowA11yLabel,
        u = e.expansionContent,
        m = e.expansionCellBorder,
        h = (0, Se.__rest)(e, ["children", "checkboxA11yLabel", "isChecked", "className", "isRowExpandable", "onRowSelect", "rowId", "isSelectable", "expandRowA11yLabel", "expansionContent", "expansionCellBorder"]),
        f = (0, _.useLocalization)(),
        g = p.useState(r),
        v = g[0],
        b = g[1],
        y = p.useContext(ea),
        x = p.useState(!1),
        k = x[0],
        N = x[1],
        w = p.useRef(null),
        L = p.useContext(Wn),
        C = n && p.Children.toArray(n).some(function (e) {
          var t;
          return (null === (t = e.props) || void 0 === t ? void 0 : t.tag) === Fn || L.tag === Fn;
        }),
        I = n && p.Children.toArray(n).some(function (e) {
          var t, n, a;
          return !0 === (null === (a = null === (n = null === (t = e.props) || void 0 === t ? void 0 : t.children) || void 0 === n ? void 0 : n.props) || void 0 === a ? void 0 : a.isOpen);
        });
      p.useEffect(function () {
        b(r);
      }, [r]);
      var R = "uitk-table-row",
        S = ia(R, i, ((t = {})["".concat(R, "-selected")] = v, t["".concat(R, "-menu")] = I, t["".concat(R, "-has-expansion-trigger")] = o && !C, t["".concat(R, "-has-expansion-trigger-active")] = o && k && !C, t)),
        A = ia("".concat(R, "-expansion-content")),
        M = ia("uitk-table-expando-trigger-icon".concat(k ? " uitk-table-expando-trigger-icon-active" : "")),
        U = p.createElement(aa, {
          className: ia("uitk-table-cell-action")
        }, p.createElement(Bn, {
          checked: v,
          labelClassName: "is-visually-hidden",
          onChange: function (e) {
            "number" == typeof s && (null == l || l(s, e.currentTarget.checked)), b(e.currentTarget.checked);
          },
          id: null == s ? void 0 : s.toString(),
          a11yLabel: a
        })),
        T = p.createElement(E.UitkIcon, {
          className: M,
          "data-testid": k ? "uitk-table-expando-button-icon-expanded" : void 0,
          name: "expand_more"
        }),
        B = p.useCallback(function () {
          N(!k);
        }, [k]),
        P = p.createElement(aa, {
          isCellExpandable: !0,
          padding: Vn,
          border: m
        }, p.createElement(ne.UitkSecondaryButton, {
          "aria-expanded": k,
          "aria-controls": null == s ? void 0 : s.toString(),
          "aria-label": null != d ? d : f.formatText("table.expand.row", void 0 === s ? "" : s + 1),
          onClick: B
        }, T)),
        j = p.createElement(p.Fragment, null, p.createElement("tr", (0, Se.__assign)({
          className: S,
          ref: w
        }, h), C ? p.createElement(aa, {
          isCellExpandable: !0,
          padding: Vn,
          border: m
        }) : o ? P : void 0, n), u && function () {
          var e;
          return p.createElement("tr", {
            className: S,
            ref: w
          }, p.createElement(aa, {
            className: "uitk-table-cell-expandable",
            colSpan: null !== (e = y.colSpan) && void 0 !== e ? e : 100,
            border: k ? m : void 0
          }, p.createElement("div", {
            className: A
          }, u)));
        }());
      return y.expandableRows || o ? j : p.createElement("tr", (0, Se.__assign)({
        className: S
      }, h), c && U, n);
    };
  oa.displayName = "UitkTableRow";
  const la = g.p + "./styles/egds-lodging-table-row.css",
    sa = x.classNames.bind(la),
    ca = e => {
      const {
          spotlightRow: t,
          className: n
        } = e,
        a = sa(n, {
          "table-row-spotlight-row": t
        });
      return (0, y.jsx)(oa, Object.assign({
        className: a
      }, e));
    };
})();
var b = v.AF,
  y = v.Zb,
  x = v.lr,
  k = v.o5,
  N = v.RX,
  E = v.N7,
  w = v.q,
  L = v.jz,
  C = v.qv,
  I = v.E7,
  R = v.et,
  S = v.vl,
  _ = v.yo,
  A = v.h1,
  M = v.OR,
  U = v.SC,
  T = v.F3,
  B = v.zV,
  P = v.rb,
  j = v.o8,
  z = v.eu,
  F = v.QA;
export { b as CalendarRatesBackground, y as Card, x as Carousel, k as EGDSLocalNeutralColorLink, N as EGDSLocalRangeIndicator, E as IconLoyaltyThemes, w as LoyaltyBadgeMuted, L as PriceNumberInput, C as PriceSlider, I as RadioButtonDescriptionExtensionWithPositiveTheme, R as RadioButtonDescriptionExtensionWithPositiveThemeGroup, S as RadioButtonDescriptionExtensionWithPositiveThemeGroupContext, _ as Sheet, A as SliderTextInputs, M as StepIndicator, U as TableRow, T as TertiaryButtonLargeIcon, B as TextLoyaltyThemes, P as ThumbnailCard, j as Toolbar, z as UitkIconLoyaltyThemes, F as UitkTextLoyaltyThemes };